import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white shadow-sm" }
const _hoisted_3 = {
  class: "card-header d-flex justify-content-between align-items-center py-4 px-4",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_4 = { class: "text-white fw-bold mb-1" }
const _hoisted_5 = { class: "text-white opacity-75" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-30 letter-spacing" }
const _hoisted_7 = {
  key: 0,
  class: "alert alert-danger border-0 shadow-sm mb-4"
}
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_9 = { class: "d-flex align-items-center gap-3" }
const _hoisted_10 = { class: "mb-1 fw-bold text-danger" }
const _hoisted_11 = { class: "ms-2" }
const _hoisted_12 = { class: "mb-0" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = {
  key: 1,
  class: "alert alert-warning border-0 shadow-sm mb-4"
}
const _hoisted_17 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_18 = { class: "d-flex align-items-center gap-3" }
const _hoisted_19 = { class: "mb-1 fw-bold" }
const _hoisted_20 = {
  key: 2,
  class: "alert alert-info border-0 shadow-sm mb-4"
}
const _hoisted_21 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_22 = { class: "d-flex align-items-center gap-3" }
const _hoisted_23 = { class: "mb-1 fw-bold" }
const _hoisted_24 = {
  key: 3,
  class: "alert alert-success border-0 shadow-sm mb-4"
}
const _hoisted_25 = {
  key: 4,
  class: "border-0 shadow-sm mb-4"
}
const _hoisted_26 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_27 = { class: "flex-grow-1" }
const _hoisted_28 = { class: "d-flex align-items-center gap-3 mb-3" }
const _hoisted_29 = { class: "mb-1 fw-bold text-primary" }
const _hoisted_30 = { class: "corrections-list" }
const _hoisted_31 = { class: "card-body p-3" }
const _hoisted_32 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_33 = { class: "flex-grow-1" }
const _hoisted_34 = { class: "d-flex align-items-center gap-2 mb-2" }
const _hoisted_35 = { class: "badge bg-warning text-dark" }
const _hoisted_36 = { class: "mb-2" }
const _hoisted_37 = { class: "mb-0 ms-3" }
const _hoisted_38 = { class: "mb-2" }
const _hoisted_39 = { class: "mb-0 ms-3 fst-italic" }
const _hoisted_40 = { class: "row text-muted small mt-2" }
const _hoisted_41 = { class: "col-md-4" }
const _hoisted_42 = { class: "col-md-4" }
const _hoisted_43 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_44 = {
  key: 0,
  class: "mt-3 p-2 bg-light rounded"
}
const _hoisted_45 = { class: "mb-0 ms-3" }
const _hoisted_46 = {
  key: 5,
  class: "alert border-start border-info border-4 mb-4"
}
const _hoisted_47 = {
  key: 6,
  class: "alert alert-success border-0 shadow-sm mb-4"
}
const _hoisted_48 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_49 = { class: "d-flex align-items-center gap-3" }
const _hoisted_50 = { class: "mb-0" }
const _hoisted_51 = { class: "d-flex align-items-center gap-3" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { class: "mb-0" }
const _hoisted_55 = { class: "text-muted" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { class: "row g-4 mb-5" }
const _hoisted_59 = { class: "col-md-4" }
const _hoisted_60 = { class: "mb-0" }
const _hoisted_61 = { class: "col-md-4" }
const _hoisted_62 = { class: "mb-0" }
const _hoisted_63 = { class: "col-md-4" }
const _hoisted_64 = { class: "mb-0" }
const _hoisted_65 = { class: "col-md-4" }
const _hoisted_66 = { class: "mb-0" }
const _hoisted_67 = { class: "col-md-4" }
const _hoisted_68 = { class: "mb-0" }
const _hoisted_69 = { class: "row g-4 mb-5" }
const _hoisted_70 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_71 = { class: "mb-0" }
const _hoisted_72 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_73 = { class: "mb-0" }
const _hoisted_74 = {
  key: 2,
  class: "col-md-3"
}
const _hoisted_75 = { class: "mb-0" }
const _hoisted_76 = {
  key: 3,
  class: "col-md-3"
}
const _hoisted_77 = { class: "mb-0" }
const _hoisted_78 = { class: "row g-4 mb-5" }
const _hoisted_79 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_80 = { class: "mb-0" }
const _hoisted_81 = { class: "col-md-4" }
const _hoisted_82 = { class: "mb-0" }
const _hoisted_83 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_84 = { class: "col-md-4" }
const _hoisted_85 = { class: "mb-0" }
const _hoisted_86 = { class: "col-md-4" }
const _hoisted_87 = { class: "mb-0" }
const _hoisted_88 = { class: "col-md-4" }
const _hoisted_89 = { class: "mb-0" }
const _hoisted_90 = { class: "col-md-4" }
const _hoisted_91 = { class: "mb-0" }
const _hoisted_92 = {
  key: 1,
  class: "col-12"
}
const _hoisted_93 = {
  key: 0,
  class: "alert alert-info"
}
const _hoisted_94 = { class: "mb-4 mt-5" }
const _hoisted_95 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_96 = { class: "text-primary fw-bold border-bottom pb-2 mb-0" }
const _hoisted_97 = {
  key: 8,
  class: "mb-5"
}
const _hoisted_98 = { class: "card-body" }
const _hoisted_99 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_100 = { class: "text-muted ms-2" }
const _hoisted_101 = { class: "btn-group btn-group-sm" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = ["onClick"]
const _hoisted_104 = { class: "mb-0" }
const _hoisted_105 = {
  key: 9,
  class: "alert alert-light text-center mb-5"
}
const _hoisted_106 = { class: "mb-4" }
const _hoisted_107 = { class: "text-primary fw-bold border-bottom pb-2" }
const _hoisted_108 = {
  key: 10,
  class: "mb-5"
}
const _hoisted_109 = {
  class: "accordion",
  id: "blAccordion"
}
const _hoisted_110 = { class: "accordion-header" }
const _hoisted_111 = ["data-bs-target", "aria-expanded", "aria-controls"]
const _hoisted_112 = { class: "badge bg-white text-primary ms-3" }
const _hoisted_113 = {
  key: 0,
  class: "badge bg-white text-primary ms-2"
}
const _hoisted_114 = ["id"]
const _hoisted_115 = { class: "accordion-body p-0" }
const _hoisted_116 = {
  key: 0,
  class: "p-3"
}
const _hoisted_117 = { class: "d-flex justify-content-between align-items-center mb-3 border-bottom pb-2" }
const _hoisted_118 = { class: "dropdown" }
const _hoisted_119 = ["onClick"]
const _hoisted_120 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_121 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_122 = { class: "flex-grow-1" }
const _hoisted_123 = { class: "d-flex align-items-center mb-1" }
const _hoisted_124 = {
  key: 0,
  class: "badge bg-info text-white me-2"
}
const _hoisted_125 = { class: "me-2" }
const _hoisted_126 = { class: "text-muted" }
const _hoisted_127 = { class: "mb-0" }
const _hoisted_128 = {
  key: 0,
  class: "text-muted d-block mt-1"
}
const _hoisted_129 = { class: "btn-group btn-group-sm ms-2" }
const _hoisted_130 = ["onClick"]
const _hoisted_131 = ["onClick"]
const _hoisted_132 = {
  key: 1,
  class: "alert alert-warning mb-3"
}
const _hoisted_133 = { class: "d-flex align-items-start" }
const _hoisted_134 = { class: "flex-grow-1" }
const _hoisted_135 = { class: "mb-0 mt-1" }
const _hoisted_136 = { class: "table-responsive" }
const _hoisted_137 = { class: "table table-hover align-middle mb-0" }
const _hoisted_138 = { class: "text-center" }
const _hoisted_139 = { class: "text-center" }
const _hoisted_140 = { class: "text-end" }
const _hoisted_141 = { class: "text-end" }
const _hoisted_142 = { class: "text-end" }
const _hoisted_143 = { class: "text-end" }
const _hoisted_144 = { class: "text-end" }
const _hoisted_145 = {
  key: 1,
  class: "p-3 bg-light border-top text-center"
}
const _hoisted_146 = ["onClick"]
const _hoisted_147 = {
  key: 2,
  class: "text-center text-muted py-4"
}
const _hoisted_148 = {
  key: 11,
  class: "text-center text-muted py-4"
}
const _hoisted_149 = {
  key: 13,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_150 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_151 = { class: "modal-content" }
const _hoisted_152 = {
  class: "modal-header",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_153 = { class: "modal-title text-white" }
const _hoisted_154 = { class: "modal-body p-4" }
const _hoisted_155 = { class: "row g-3" }
const _hoisted_156 = { class: "card border-primary h-100 shadow-sm" }
const _hoisted_157 = { class: "card-header bg-primary text-white" }
const _hoisted_158 = { class: "card-body" }
const _hoisted_159 = { class: "mb-3 pb-3 border-bottom" }
const _hoisted_160 = { class: "mb-0 fw-bold text-primary fs-5" }
const _hoisted_161 = { class: "row g-3" }
const _hoisted_162 = { class: "col-4" }
const _hoisted_163 = {
  key: 0,
  class: "mb-0 text-dark fw-bold"
}
const _hoisted_164 = {
  key: 1,
  class: "mb-0 text-muted small fst-italic"
}
const _hoisted_165 = { class: "col-4" }
const _hoisted_166 = {
  key: 0,
  class: "mb-0 text-dark fw-bold"
}
const _hoisted_167 = {
  key: 1,
  class: "mb-0 text-muted small fst-italic"
}
const _hoisted_168 = { class: "col-4" }
const _hoisted_169 = {
  key: 0,
  class: "mb-0 text-dark fw-bold"
}
const _hoisted_170 = {
  key: 1,
  class: "mb-0 text-muted small fst-italic"
}
const _hoisted_171 = { class: "modal-footer bg-light" }
const _hoisted_172 = {
  key: 14,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_173 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_174 = { class: "modal-content" }
const _hoisted_175 = {
  class: "modal-header",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_176 = { class: "modal-title text-white" }
const _hoisted_177 = { class: "modal-body p-4" }
const _hoisted_178 = { class: "alert alert-info mb-4" }
const _hoisted_179 = { key: 0 }
const _hoisted_180 = { key: 1 }
const _hoisted_181 = { key: 2 }
const _hoisted_182 = { key: 3 }
const _hoisted_183 = {
  key: 0,
  class: "form-group mb-3"
}
const _hoisted_184 = { class: "form-group mb-3" }
const _hoisted_185 = { class: "text-muted" }
const _hoisted_186 = { key: 0 }
const _hoisted_187 = { key: 1 }
const _hoisted_188 = { class: "form-group" }
const _hoisted_189 = { class: "text-muted" }
const _hoisted_190 = { class: "modal-footer bg-light" }
const _hoisted_191 = { class: "mb-4" }
const _hoisted_192 = { class: "text-primary fw-bold border-bottom pb-2" }
const _hoisted_193 = {
  key: 15,
  class: "row g-3"
}
const _hoisted_194 = { class: "border rounded p-3 d-flex align-items-center justify-content-between" }
const _hoisted_195 = { class: "text-muted" }
const _hoisted_196 = { class: "d-flex gap-1" }
const _hoisted_197 = ["onClick"]
const _hoisted_198 = ["onClick"]
const _hoisted_199 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_200 = { class: "text-muted d-block mb-1" }
const _hoisted_201 = { class: "d-flex justify-content-between" }
const _hoisted_202 = ["onClick"]
const _hoisted_203 = ["onClick"]
const _hoisted_204 = { class: "mb-0 mt-1" }
const _hoisted_205 = {
  key: 16,
  class: "text-center text-muted py-4"
}
const _hoisted_206 = {
  key: 18,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_207 = {
  class: "modal-dialog modal-xl modal-dialog-centered",
  style: {"max-width":"90vw"}
}
const _hoisted_208 = {
  class: "modal-content",
  style: {"height":"90vh"}
}
const _hoisted_209 = {
  class: "modal-header",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_210 = { class: "modal-title text-white" }
const _hoisted_211 = {
  class: "modal-body p-0 d-flex align-items-center justify-content-center bg-dark",
  style: {"flex":"1","overflow":"hidden"}
}
const _hoisted_212 = {
  key: 0,
  class: "text-center text-white"
}
const _hoisted_213 = ["src"]
const _hoisted_214 = ["src"]
const _hoisted_215 = {
  key: 3,
  class: "text-center text-white p-4"
}
const _hoisted_216 = { class: "modal-footer bg-light" }
const _hoisted_217 = {
  key: 19,
  class: "text-center text-muted py-4"
}
const _hoisted_218 = { class: "timeline" }
const _hoisted_219 = { class: "timeline-content" }
const _hoisted_220 = { class: "fw-bold mb-1" }
const _hoisted_221 = { class: "text-muted small" }
const _hoisted_222 = { class: "mb-0 small" }
const _hoisted_223 = { key: 0 }
const _hoisted_224 = {
  key: 20,
  class: "mb-4 mt-5"
}
const _hoisted_225 = {
  key: 21,
  class: "mb-5"
}
const _hoisted_226 = { class: "table-responsive" }
const _hoisted_227 = { class: "table table-hover align-middle" }
const _hoisted_228 = { class: "badge bg-secondary" }
const _hoisted_229 = { class: "text-center" }
const _hoisted_230 = {
  key: 0,
  class: "fas fa-check-circle text-success fs-5",
  title: "Exécuté à la création"
}
const _hoisted_231 = {
  key: 1,
  class: "fas fa-times-circle text-muted fs-5",
  title: "Non exécuté à la création"
}
const _hoisted_232 = { class: "text-center" }
const _hoisted_233 = {
  key: 0,
  class: "fas fa-check-circle text-success fs-5",
  title: "Exécuté à la mise à jour"
}
const _hoisted_234 = {
  key: 1,
  class: "fas fa-times-circle text-muted fs-5",
  title: "Non exécuté à la mise à jour"
}
const _hoisted_235 = { class: "text-center" }
const _hoisted_236 = {
  key: 0,
  class: "fas fa-check-circle text-danger fs-5",
  title: "Contrôle bloquant avant émission"
}
const _hoisted_237 = {
  key: 1,
  class: "fas fa-times-circle text-muted fs-5",
  title: "Non bloquant à l'émission"
}
const _hoisted_238 = {
  key: 0,
  class: "badge bg-info"
}
const _hoisted_239 = {
  key: 1,
  class: "text-muted small"
}
const _hoisted_240 = {
  key: 22,
  class: "alert alert-light text-center mb-5"
}
const _hoisted_241 = {
  key: 23,
  class: "mb-4 mt-5"
}
const _hoisted_242 = { class: "card border-0 shadow-sm" }
const _hoisted_243 = { class: "card-body" }
const _hoisted_244 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_245 = { class: "text-muted" }
const _hoisted_246 = {
  class: "progress mb-3",
  style: {"height":"30px","border-radius":"10px"}
}
const _hoisted_247 = { class: "d-flex gap-4 flex-wrap small" }
const _hoisted_248 = { class: "d-flex align-items-center gap-2" }
const _hoisted_249 = { class: "d-flex align-items-center gap-2" }
const _hoisted_250 = { class: "d-flex align-items-center gap-2" }
const _hoisted_251 = {
  key: 24,
  class: "alert alert-light border border-primary shadow-sm mb-4 mt-4"
}
const _hoisted_252 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_253 = { class: "d-flex align-items-center gap-3" }
const _hoisted_254 = { class: "mb-0" }
const _hoisted_255 = { class: "mt-3" }
const _hoisted_256 = { class: "flex-grow-1" }
const _hoisted_257 = { class: "fw-semibold" }
const _hoisted_258 = { class: "mb-0 small text-muted" }
const _hoisted_259 = {
  key: 25,
  class: "border border-warning shadow-sm mb-4 mt-4"
}
const _hoisted_260 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_261 = { class: "d-flex align-items-center gap-3" }
const _hoisted_262 = { class: "mb-0" }
const _hoisted_263 = {
  key: 26,
  class: "shadow-sm mb-4 mt-4"
}
const _hoisted_264 = {
  key: 27,
  class: "section-title mb-4 mt-5"
}
const _hoisted_265 = { class: "text-primary fw-bold border-bottom pb-2" }
const _hoisted_266 = {
  key: 28,
  class: "mb-5"
}
const _hoisted_267 = {
  class: "accordion",
  id: "tasksAccordion"
}
const _hoisted_268 = { class: "accordion-header" }
const _hoisted_269 = ["data-bs-target", "aria-controls"]
const _hoisted_270 = { class: "d-flex justify-content-between align-items-center w-100 pe-3" }
const _hoisted_271 = { class: "d-flex gap-2 align-items-center" }
const _hoisted_272 = {
  key: 0,
  class: "badge bg-primary"
}
const _hoisted_273 = {
  key: 1,
  class: "badge bg-info"
}
const _hoisted_274 = ["id"]
const _hoisted_275 = { class: "accordion-body" }
const _hoisted_276 = { class: "row mb-4" }
const _hoisted_277 = { class: "col-md-4" }
const _hoisted_278 = { class: "fw-bold mb-0" }
const _hoisted_279 = { class: "col-md-4" }
const _hoisted_280 = { class: "fw-bold mb-0" }
const _hoisted_281 = { class: "col-md-4" }
const _hoisted_282 = { class: "mb-0" }
const _hoisted_283 = {
  key: 0,
  class: "col-12 mt-3"
}
const _hoisted_284 = { class: "mb-0 p-3 bg-light rounded" }
const _hoisted_285 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_286 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_287 = { class: "text-muted" }
const _hoisted_288 = {
  class: "progress mb-2",
  style: {"height":"8px"}
}
const _hoisted_289 = ["aria-valuenow"]
const _hoisted_290 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_291 = { class: "text-muted" }
const _hoisted_292 = {
  key: 1,
  class: "border-top pt-4 mb-4"
}
const _hoisted_293 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_294 = { class: "mb-0" }
const _hoisted_295 = {
  key: 0,
  class: "d-flex gap-2 flex-wrap"
}
const _hoisted_296 = { class: "badge bg-success" }
const _hoisted_297 = { class: "badge bg-danger" }
const _hoisted_298 = { class: "badge bg-warning text-dark" }
const _hoisted_299 = { class: "badge bg-secondary" }
const _hoisted_300 = {
  key: 0,
  class: "alert alert-success text-dark"
}
const _hoisted_301 = { class: "row g-3" }
const _hoisted_302 = { class: "card-body p-3" }
const _hoisted_303 = { class: "d-flex justify-content-between align-items-start mb-3" }
const _hoisted_304 = { class: "d-flex align-items-start gap-2 flex-grow-1" }
const _hoisted_305 = { class: "badge bg-primary fs-6" }
const _hoisted_306 = { class: "flex-grow-1" }
const _hoisted_307 = { class: "mb-2 fw-bold" }
const _hoisted_308 = { class: "d-flex gap-2 mb-2 flex-wrap" }
const _hoisted_309 = {
  key: 0,
  class: "badge bg-secondary small"
}
const _hoisted_310 = { class: "mb-0 text-muted small" }
const _hoisted_311 = { class: "border-top pt-3" }
const _hoisted_312 = {
  key: 0,
  class: "alert alert-danger p-2 mb-3"
}
const _hoisted_313 = { class: "mb-3" }
const _hoisted_314 = { class: "form-label small fw-semibold mb-2" }
const _hoisted_315 = {
  key: 0,
  class: "badge bg-info ms-2 small"
}
const _hoisted_316 = { class: "mb-2" }
const _hoisted_317 = ["value", "onBlur", "disabled"]
const _hoisted_318 = { class: "text-muted d-block mt-1" }
const _hoisted_319 = {
  key: 1,
  class: "mt-2 p-2 bg-light rounded"
}
const _hoisted_320 = { class: "text-muted" }
const _hoisted_321 = {
  key: 2,
  class: "alert alert-warning text-center"
}
const _hoisted_322 = { class: "border-top pt-4 mt-4" }
const _hoisted_323 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_324 = { class: "mb-0" }
const _hoisted_325 = { class: "btn-group gap-2" }
const _hoisted_326 = ["onClick"]
const _hoisted_327 = { key: 0 }
const _hoisted_328 = { class: "card-body p-3" }
const _hoisted_329 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_330 = {
  key: 0,
  class: "badge bg-info text-white me-2"
}
const _hoisted_331 = { class: "text-muted ms-2" }
const _hoisted_332 = { class: "btn-group btn-group-sm" }
const _hoisted_333 = ["onClick"]
const _hoisted_334 = ["onClick"]
const _hoisted_335 = { class: "mb-0" }
const _hoisted_336 = {
  key: 1,
  class: "alert alert-light text-center"
}
const _hoisted_337 = {
  key: 3,
  class: "border-top pt-3 mt-3 text-end"
}
const _hoisted_338 = ["onClick", "disabled"]
const _hoisted_339 = {
  key: 1,
  class: "d-block text-muted mt-2"
}
const _hoisted_340 = {
  key: 4,
  class: "alert alert-success text-center mb-0"
}
const _hoisted_341 = {
  key: 29,
  class: "alert alert-info text-center py-5"
}
const _hoisted_342 = {
  key: 30,
  class: "text-center py-5"
}
const _hoisted_343 = { class: "d-flex justify-content-between mt-5 pt-4 border-top" }
const _hoisted_344 = { class: "btn-group" }
const _hoisted_345 = {
  key: 1,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_346 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_347 = { class: "modal-content" }
const _hoisted_348 = { class: "text-black" }
const _hoisted_349 = { class: "d-flex gap-4 small" }
const _hoisted_350 = { key: 0 }
const _hoisted_351 = { key: 1 }
const _hoisted_352 = { key: 2 }
const _hoisted_353 = { class: "modal-body p-4" }
const _hoisted_354 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_355 = { class: "d-flex align-items-center mb-3 pb-2 border-bottom border-danger" }
const _hoisted_356 = { class: "mb-0 fw-bold text-danger" }
const _hoisted_357 = { class: "card-body" }
const _hoisted_358 = { class: "d-flex justify-content-between align-items-start mb-3" }
const _hoisted_359 = { class: "d-flex align-items-start gap-2" }
const _hoisted_360 = { class: "badge bg-danger fs-6" }
const _hoisted_361 = { class: "mb-1 fw-bold text-danger" }
const _hoisted_362 = { class: "badge bg-danger" }
const _hoisted_363 = { class: "badge bg-dark ms-1" }
const _hoisted_364 = { class: "alert alert-light mb-3" }
const _hoisted_365 = { class: "row text-muted small" }
const _hoisted_366 = { class: "col-md-6" }
const _hoisted_367 = { class: "col-md-6" }
const _hoisted_368 = {
  key: 1,
  class: "mb-5"
}
const _hoisted_369 = { class: "d-flex align-items-center mb-3 pb-2 border-bottom border-danger" }
const _hoisted_370 = { class: "mb-0 fw-bold text-danger" }
const _hoisted_371 = { class: "card-body" }
const _hoisted_372 = { class: "d-flex justify-content-between align-items-start mb-3" }
const _hoisted_373 = { class: "d-flex align-items-start gap-2" }
const _hoisted_374 = { class: "badge bg-danger fs-6" }
const _hoisted_375 = { class: "mb-1 fw-bold text-danger" }
const _hoisted_376 = { class: "badge bg-danger" }
const _hoisted_377 = { class: "badge bg-dark ms-1" }
const _hoisted_378 = { class: "alert alert-light mb-3" }
const _hoisted_379 = { class: "row text-muted small" }
const _hoisted_380 = { class: "col-md-6" }
const _hoisted_381 = { class: "col-md-6" }
const _hoisted_382 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_383 = { class: "d-flex align-items-center mb-3 pb-2 border-bottom border-info" }
const _hoisted_384 = { class: "mb-0 fw-bold text-info" }
const _hoisted_385 = {
  class: "accordion",
  id: "warningsAccordion"
}
const _hoisted_386 = { class: "accordion-header" }
const _hoisted_387 = ["data-bs-target"]
const _hoisted_388 = { class: "badge bg-info me-2" }
const _hoisted_389 = ["id"]
const _hoisted_390 = { class: "accordion-body" }
const _hoisted_391 = { class: "text-muted" }
const _hoisted_392 = {
  key: 3,
  class: "text-center py-5"
}
const _hoisted_393 = { class: "modal-footer bg-light" }
const _hoisted_394 = { class: "d-flex justify-content-between w-100 align-items-center" }
const _hoisted_395 = {
  key: 3,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_396 = { class: "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" }
const _hoisted_397 = { class: "modal-content" }
const _hoisted_398 = { class: "modal-header bg-primary py-2" }
const _hoisted_399 = { class: "text-white" }
const _hoisted_400 = { class: "modal-title mb-0 text-white" }
const _hoisted_401 = { class: "modal-body p-3" }
const _hoisted_402 = { class: "mb-3" }
const _hoisted_403 = {
  class: "corrections-list border rounded p-2",
  style: {"max-height":"200px","overflow-y":"auto","background-color":"#f8f9fa"}
}
const _hoisted_404 = {
  class: "badge bg-primary d-flex align-items-center justify-content-center flex-shrink-0",
  style: {"width":"20px","height":"20px","border-radius":"4px","font-size":"10px"}
}
const _hoisted_405 = { class: "flex-grow-1 small" }
const _hoisted_406 = { class: "fw-semibold text-dark" }
const _hoisted_407 = { class: "text-muted" }
const _hoisted_408 = { class: "text-primary mt-1" }
const _hoisted_409 = { class: "row g-2" }
const _hoisted_410 = { class: "col-md-6" }
const _hoisted_411 = { class: "col-md-6" }
const _hoisted_412 = { class: "col-12" }
const _hoisted_413 = { class: "modal-footer bg-light mt-3 py-2" }
const _hoisted_414 = {
  key: 5,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_415 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_416 = { class: "modal-content" }
const _hoisted_417 = { class: "modal-header bg-primary text-white" }
const _hoisted_418 = { class: "modal-body" }
const _hoisted_419 = { class: "mb-3" }
const _hoisted_420 = { class: "row" }
const _hoisted_421 = { class: "col-6" }
const _hoisted_422 = { class: "card bg-light" }
const _hoisted_423 = { class: "card-body text-center py-2" }
const _hoisted_424 = { class: "mb-1" }
const _hoisted_425 = { class: "col-6" }
const _hoisted_426 = { class: "card bg-success text-white" }
const _hoisted_427 = { class: "card-body text-center py-2" }
const _hoisted_428 = { class: "mb-1" }
const _hoisted_429 = { class: "form-group" }
const _hoisted_430 = { class: "modal-footer" }
const _hoisted_431 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h3", _hoisted_4, " Détail du BESC – " + _toDisplayString(_ctx.besc.refbesc || 'Chargement...'), 1),
            _createElementVNode("small", _hoisted_5, " Référence : " + _toDisplayString(_ctx.besc.refbesc) + " . Créé le " + _toDisplayString(_ctx.formatDate(_ctx.besc.createdAt)), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", {
              class: _normalizeClass(["badge fs-5 px-4 py-2", _ctx.statusBadgeClass])
            }, _toDisplayString(_ctx.statusLabel), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.totalCriticalFlags > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _cache[33] || (_cache[33] = _createElementVNode("i", { class: "fas fa-ban fa-2x text-danger" }, null, -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("h5", _hoisted_10, [
                        _cache[31] || (_cache[31] = _createTextVNode(" ÉMISSION BLOQUÉE ", -1)),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.totalCriticalFlags) + " anomalie(s) critique(s) ", 1)
                      ]),
                      _createElementVNode("p", _hoisted_12, [
                        (_ctx.totalBlockingFlags > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.totalBlockingFlags) + " bloquante(s) ", 1))
                          : _createCommentVNode("", true),
                        (_ctx.totalBlockingFlags > 0 && _ctx.totalHighRiskFlags > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14))
                          : _createCommentVNode("", true),
                        (_ctx.totalHighRiskFlags > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.totalHighRiskFlags) + " risque(s) élevé(s) ", 1))
                          : _createCommentVNode("", true),
                        _cache[32] || (_cache[32] = _createTextVNode(" Ce BESC ne peut pas être émis. ", -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFlagsModal = true)),
                    class: "btn btn-danger"
                  }, [
                    _cache[34] || (_cache[34] = _createElementVNode("i", { class: "flaticon-exclamation-triangle me-2" }, null, -1)),
                    _createTextVNode(" Voir les " + _toDisplayString(_ctx.totalCriticalFlags) + " alerte(s) ", 1)
                  ])
                ])
              ]))
            : (_ctx.totalWarningFlags > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[36] || (_cache[36] = _createElementVNode("i", { class: "fas fa-info-circle fa-2x text-warning" }, null, -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("h6", _hoisted_19, " Avertissements (" + _toDisplayString(_ctx.totalWarningFlags) + ") ", 1),
                        _cache[35] || (_cache[35] = _createElementVNode("p", { class: "mb-0" }, " Points d'attention détectés — N'empêchent pas l'émission ", -1))
                      ])
                    ]),
                    _createElementVNode("button", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFlagsModal = true)),
                      class: "btn btn-warning"
                    }, " Consulter ")
                  ])
                ]))
              : (_ctx.totalInfoFlags > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _cache[38] || (_cache[38] = _createElementVNode("i", { class: "fas fa-lightbulb fa-2x text-info" }, null, -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("h6", _hoisted_23, " Informations (" + _toDisplayString(_ctx.totalInfoFlags) + ")", 1),
                          _cache[37] || (_cache[37] = _createElementVNode("p", { class: "mb-0" }, "Éléments à noter pour ce dossier", -1))
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showFlagsModal = true)),
                        class: "btn btn-info"
                      }, "Voir")
                    ])
                  ]))
                : (!_ctx.loading && _ctx.totalAllFlags === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[39] || (_cache[39] = [
                      _createElementVNode("div", { class: "d-flex align-items-center gap-3" }, [
                        _createElementVNode("i", { class: "fas fa-check-circle fa-2x text-success" }),
                        _createElementVNode("div", null, [
                          _createElementVNode("h6", { class: "mb-1 fw-bold text-success" }, " Aucune alerte détectée"),
                          _createElementVNode("p", { class: "mb-0" }, "Tous les contrôles sont passés avec succès.")
                        ])
                      ], -1)
                    ]))]))
                  : _createCommentVNode("", true),
          (_ctx.correctionRetourne.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _cache[42] || (_cache[42] = _createElementVNode("i", { class: "fas fa-reply fa-2x text-warning" }, null, -1)),
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_29, [
                          _cache[40] || (_cache[40] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
                          _createTextVNode(" Corrections demandées (" + _toDisplayString(_ctx.correctionRetourne.length) + ") ", 1)
                        ]),
                        _cache[41] || (_cache[41] = _createElementVNode("p", { class: "mb-0" }, " Des corrections ont été demandées par l'agent validateur ", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.correctionRetourne, (correction, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: correction.id,
                          class: "card mb-2 border-warning"
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("span", _hoisted_35, " Correction " + _toDisplayString(index + 1), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["badge", {
                            'bg-danger': correction.status === 'OPEN',
                            'bg-success': correction.status === 'RESOLVED',
                            'bg-secondary': correction.status === 'CANCELLED'
                          }])
                                  }, _toDisplayString(correction.status === 'OPEN' ? 'En attente' :
                              correction.status === 'RESOLVED' ? 'Résolu' : 'Annulé'), 3)
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  _cache[43] || (_cache[43] = _createElementVNode("strong", { class: "text-primary" }, [
                                    _createElementVNode("i", { class: "fas fa-edit me-1" }),
                                    _createTextVNode(" Champs concernés : ")
                                  ], -1)),
                                  _createElementVNode("p", _hoisted_37, _toDisplayString(correction.fields_concerned), 1)
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _cache[44] || (_cache[44] = _createElementVNode("strong", { class: "text-danger" }, [
                                    _createElementVNode("i", { class: "fas fa-comment-dots me-1" }),
                                    _createTextVNode(" Message de l'agent : ")
                                  ], -1)),
                                  _createElementVNode("p", _hoisted_39, _toDisplayString(correction.message_to_requester), 1)
                                ]),
                                _createElementVNode("div", _hoisted_40, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _cache[45] || (_cache[45] = _createElementVNode("i", { class: "fas fa-calendar me-1" }, null, -1)),
                                    _cache[46] || (_cache[46] = _createElementVNode("strong", null, "Demandé le :", -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(correction.requested_at)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_42, [
                                    _cache[47] || (_cache[47] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1)),
                                    _cache[48] || (_cache[48] = _createElementVNode("strong", null, "Échéance :", -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.formatDate(correction.due_date)), 1)
                                  ]),
                                  (correction.responded_at)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                        _cache[49] || (_cache[49] = _createElementVNode("i", { class: "fas fa-check me-1 text-success" }, null, -1)),
                                        _cache[50] || (_cache[50] = _createElementVNode("strong", null, "Répondu le :", -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(correction.responded_at)), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (correction.response_message)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _cache[51] || (_cache[51] = _createElementVNode("strong", { class: "text-success" }, [
                                        _createElementVNode("i", { class: "fas fa-reply me-1" }),
                                        _createTextVNode(" Votre réponse : ")
                                      ], -1)),
                                      _createElementVNode("p", _hoisted_45, _toDisplayString(correction.response_message), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isReverificationNeeded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [...(_cache[52] || (_cache[52] = [
                _createElementVNode("div", { class: "d-flex align-items-center gap-3" }, [
                  _createElementVNode("i", { class: "fas fa-redo fa-2x text-info" }),
                  _createElementVNode("div", null, [
                    _createElementVNode("h6", { class: "mb-1 fw-bold" }, "Re-vérification requise"),
                    _createElementVNode("p", { class: "mb-0" }, "Ce dossier a été corrigé par le demandeur. Une nouvelle vérification complète est nécessaire.")
                  ])
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.isDossierValidated && !_ctx.isAlreadyValidatedByAgent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _cache[54] || (_cache[54] = _createElementVNode("i", { class: "fas fa-check-circle fa-2x text-success" }, null, -1)),
                    _createElementVNode("div", null, [
                      _cache[53] || (_cache[53] = _createElementVNode("h5", { class: "mb-1 fw-bold text-success" }, [
                        _createElementVNode("i", { class: "flaticon-check-mark me-2" }),
                        _createTextVNode(" DOSSIER PRÊT POUR DÉCISION ")
                      ], -1)),
                      _createElementVNode("p", _hoisted_50, " Tous les contrôles sont terminés (" + _toDisplayString(_ctx.getTotalChecksCount()) + " checks complétés). Aucune alerte critique. Vous pouvez valider ou rejeter le dossier. ", 1)
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showValidationModal = true)),
                    class: "btn btn-primary"
                  }, [...(_cache[55] || (_cache[55] = [
                    _createElementVNode("i", { class: "fas fa-clipboard-check me-2" }, null, -1),
                    _createTextVNode(" PRENDRE UNE DÉCISION ", -1)
                  ]))])
                ])
              ]))
            : (_ctx.isAlreadyValidatedByAgent)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 7,
                  class: _normalizeClass(["alert border-0 shadow-sm mb-4", {
          'alert-success': _ctx.getAgentValidationStatus() === 'VALIDATED',
          'alert-danger': _ctx.getAgentValidationStatus() === 'REJECTED'
        }])
                }, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fa-2x", {
              'fas fa-check-circle text-success': _ctx.getAgentValidationStatus() === 'VALIDATED',
              'fas fa-times-circle text-danger': _ctx.getAgentValidationStatus() === 'REJECTED'
            }])
                    }, null, 2),
                    _createElementVNode("div", null, [
                      _createElementVNode("h5", {
                        class: _normalizeClass(["mb-1 fw-bold", {
                'text-success': _ctx.getAgentValidationStatus() === 'VALIDATED',
                'text-danger': _ctx.getAgentValidationStatus() === 'REJECTED'
              }])
                      }, [
                        (_ctx.getAgentValidationStatus() === 'VALIDATED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_52, " DOSSIER VALIDÉ PAR L'AGENT "))
                          : (_openBlock(), _createElementBlock("span", _hoisted_53, " DOSSIER REJETÉ PAR L'AGENT "))
                      ], 2),
                      _createElementVNode("p", _hoisted_54, [
                        _createTextVNode(_toDisplayString(_ctx.getAgentValidationStatus() === 'VALIDATED' ? 'Validé' : 'Rejeté') + " le " + _toDisplayString(_ctx.formatDateTime(_ctx.getAgentValidationDate())) + " ", 1),
                        _cache[56] || (_cache[56] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("small", _hoisted_55, [
                          (_ctx.getAgentValidationStatus() === 'VALIDATED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_56, " En attente d'approbation superviseur "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_57, " Dossier remis en correction "))
                        ])
                      ])
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true),
          _cache[176] || (_cache[176] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Informations générales")
          ], -1)),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", _hoisted_59, [
              _cache[57] || (_cache[57] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Numéro de connaissement", -1)),
              _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.besc.numeroConnaissement || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _cache[58] || (_cache[58] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Pays d'origine", -1)),
              _createElementVNode("p", _hoisted_62, _toDisplayString(_ctx.besc.paysOrigine?.name_fr || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_63, [
              _cache[59] || (_cache[59] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Incoterm", -1)),
              _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.besc.incoterm?.code || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_65, [
              _cache[60] || (_cache[60] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Type de paiement fret", -1)),
              _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.besc.typeFret?.libelle || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_67, [
              _cache[61] || (_cache[61] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Destination finale", -1)),
              _createElementVNode("p", _hoisted_68, _toDisplayString(_ctx.besc.destinationFinalePays?.name_fr || '-'), 1)
            ])
          ]),
          _cache[177] || (_cache[177] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Parties prenantes")
          ], -1)),
          _createElementVNode("div", _hoisted_69, [
            (_ctx.importateur)
              ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                  _cache[62] || (_cache[62] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Expéditeur", -1)),
                  _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.importateur.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.importateur)
              ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  _cache[63] || (_cache[63] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Importateur", -1)),
                  _createElementVNode("p", _hoisted_73, _toDisplayString(_ctx.importateur.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.transitaire)
              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                  _cache[64] || (_cache[64] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Transitaire", -1)),
                  _createElementVNode("p", _hoisted_75, _toDisplayString(_ctx.transitaire.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.partieANotifier)
              ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                  _cache[65] || (_cache[65] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Partie à notifier", -1)),
                  _createElementVNode("p", _hoisted_77, _toDisplayString(_ctx.partieANotifier.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[178] || (_cache[178] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Transport & itinéraire")
          ], -1)),
          _createElementVNode("div", _hoisted_78, [
            (_ctx.transporteur)
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  _cache[66] || (_cache[66] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Transporteur", -1)),
                  _createElementVNode("p", _hoisted_80, _toDisplayString(_ctx.transporteur.acteur.nomComplet || '-'), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_81, [
              _cache[67] || (_cache[67] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Navire", -1)),
              _createElementVNode("p", _hoisted_82, [
                _createTextVNode(_toDisplayString(_ctx.besc.vessel?.name || '-') + " ", 1),
                (_ctx.besc.vessel?.imo)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_83, "(IMO: " + _toDisplayString(_ctx.besc.vessel.imo) + ")", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_84, [
              _cache[68] || (_cache[68] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Port de chargement", -1)),
              _createElementVNode("p", _hoisted_85, _toDisplayString(_ctx.besc.portChargement?.nomPort || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_86, [
              _cache[69] || (_cache[69] = _createElementVNode("label", { class: "text-black fw-semibold" }, "Port de déchargement", -1)),
              _createElementVNode("p", _hoisted_87, _toDisplayString(_ctx.besc.portDechargement?.nomPort || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_88, [
              _cache[70] || (_cache[70] = _createElementVNode("label", { class: "text-black fw-semibold" }, "ETD (Départ estimé)", -1)),
              _createElementVNode("p", _hoisted_89, _toDisplayString(_ctx.formatDate(_ctx.besc.etd)), 1)
            ]),
            _createElementVNode("div", _hoisted_90, [
              _cache[71] || (_cache[71] = _createElementVNode("label", { class: "text-black fw-semibold" }, "ETA (Arrivée estimée)", -1)),
              _createElementVNode("p", _hoisted_91, _toDisplayString(_ctx.formatDate(_ctx.besc.eta)), 1)
            ]),
            (_ctx.besc.transbordement === 'oui')
              ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                  (_ctx.transbordement)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                        _cache[72] || (_cache[72] = _createElementVNode("strong", null, "Transbordement :", -1)),
                        _cache[73] || (_cache[73] = _createTextVNode(" Oui", -1)),
                        _cache[74] || (_cache[74] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" Navire après transbordement : " + _toDisplayString(_ctx.besc.navireApresTransbordement?.name || '-'), 1),
                        _cache[75] || (_cache[75] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" Transporteur après transbordement : " + _toDisplayString(_ctx.transbordement.acteur.nomComplet || '-' || '-'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("h5", _hoisted_96, " Commentaires globaux (" + _toDisplayString(_ctx.globalComments.length) + ") ", 1),
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openGlobalCommentModal && _ctx.openGlobalCommentModal(...args))),
                class: "btn btn-sm btn-primary"
              }, [...(_cache[76] || (_cache[76] = [
                _createElementVNode("i", { class: "fas fa-plus me-2" }, null, -1),
                _createTextVNode(" Ajouter un commentaire ", -1)
              ]))])
            ])
          ]),
          (_ctx.globalComments.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.globalComments, (comment) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: comment.id,
                    class: _normalizeClass(["card mb-3 shadow-sm", comment.visibility === 'EXTERNAL' ? 'border-warning' : 'border-secondary'])
                  }, [
                    _createElementVNode("div", _hoisted_98, [
                      _createElementVNode("div", _hoisted_99, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["badge me-2", comment.visibility === 'EXTERNAL' ? 'bg-warning text-dark' : 'bg-secondary'])
                          }, [
                            _createElementVNode("i", {
                              class: _normalizeClass(comment.visibility === 'EXTERNAL' ? 'fas fa-eye' : 'fas fa-lock')
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(comment.visibility === 'EXTERNAL' ? 'Externe' : 'Interne'), 1)
                          ], 2),
                          _createElementVNode("strong", null, _toDisplayString(comment.author?.username || 'Utilisateur'), 1),
                          _createElementVNode("small", _hoisted_100, _toDisplayString(_ctx.formatDateTime(comment.createdAt)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_101, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.editComment(comment)),
                            class: "btn btn-outline-primary"
                          }, [...(_cache[77] || (_cache[77] = [
                            _createElementVNode("i", { class: "flaticon-edit" }, null, -1)
                          ]))], 8, _hoisted_102),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.deleteComment(comment.id)),
                            class: "btn btn-outline-danger"
                          }, [...(_cache[78] || (_cache[78] = [
                            _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                          ]))], 8, _hoisted_103)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_104, _toDisplayString(comment.commentText), 1)
                    ])
                  ], 2))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_105, [...(_cache[79] || (_cache[79] = [
                _createElementVNode("i", { class: "fas fa-comment-slash fa-2x text-muted mb-2" }, null, -1),
                _createElementVNode("p", { class: "mb-0 text-muted" }, "Aucun commentaire global pour ce dossier", -1)
              ]))])),
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("h5", _hoisted_107, " Marchandises (" + _toDisplayString(_ctx.totalMarchandises) + ") ", 1)
          ]),
          (_ctx.besc.bls?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_108, [
                _createElementVNode("div", _hoisted_109, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.besc.bls, (bl, blIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: blIndex,
                      class: "accordion-item border mb-3 shadow-sm"
                    }, [
                      _createElementVNode("h2", _hoisted_110, [
                        _createElementVNode("button", {
                          class: "accordion-button collapsed bg-blue-header text-white fw-bold",
                          type: "button",
                          "data-bs-toggle": 'collapse',
                          "data-bs-target": '#bl' + blIndex,
                          "aria-expanded": blIndex === 0 ? 'true' : 'false',
                          "aria-controls": 'bl' + blIndex
                        }, [
                          _cache[80] || (_cache[80] = _createElementVNode("i", { class: "fas fa-file-alt me-3" }, null, -1)),
                          _createTextVNode(" BL N° " + _toDisplayString(bl.blNumber) + " ", 1),
                          _createElementVNode("span", _hoisted_112, _toDisplayString(bl.bescLignes?.length || 0) + " marchandise(s) ", 1),
                          (bl.conteneurs?.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(bl.conteneurs.length) + " conteneur(s) ", 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_111)
                      ]),
                      _createElementVNode("div", {
                        id: 'bl' + blIndex,
                        class: _normalizeClass(["accordion-collapse collapse", { show: blIndex === 0 }]),
                        "data-bs-parent": "#blAccordion"
                      }, [
                        _createElementVNode("div", _hoisted_115, [
                          (bl.bescLignes?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                                _createElementVNode("div", _hoisted_117, [
                                  _cache[82] || (_cache[82] = _createElementVNode("h6", { class: "text-primary fw-bold mb-0" }, [
                                    _createElementVNode("i", { class: "fas fa-boxes me-2" }),
                                    _createTextVNode("Détail des marchandises ")
                                  ], -1)),
                                  _createElementVNode("div", _hoisted_118, [
                                    _createElementVNode("button", {
                                      class: "btn btn-sm btn-outline-primary",
                                      onClick: ($event: any) => (_ctx.openCommentModal(bl, Number(blIndex)))
                                    }, [...(_cache[81] || (_cache[81] = [
                                      _createElementVNode("i", { class: "fas fa-comment-dots me-1" }, null, -1),
                                      _createTextVNode(" Ajouter un commentaire ", -1)
                                    ]))], 8, _hoisted_119)
                                  ])
                                ]),
                                (_ctx.getBlComments(bl.id).length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                                      _cache[87] || (_cache[87] = _createElementVNode("h6", { class: "text-muted small mb-2" }, [
                                        _createElementVNode("i", { class: "fas fa-comments me-1" }),
                                        _createTextVNode(" Commentaires sur ce BL ")
                                      ], -1)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBlComments(bl.id), (comment) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: comment.id,
                                          class: _normalizeClass(["alert mb-2", comment.visibility === 'EXTERNAL' ? 'alert-warning' : 'alert-secondary'])
                                        }, [
                                          _createElementVNode("div", _hoisted_121, [
                                            _createElementVNode("div", _hoisted_122, [
                                              _createElementVNode("div", _hoisted_123, [
                                                _createElementVNode("span", {
                                                  class: _normalizeClass(["badge me-2", comment.visibility === 'EXTERNAL' ? 'bg-warning text-dark' : 'bg-secondary'])
                                                }, _toDisplayString(comment.visibility === 'EXTERNAL' ? 'Externe' : 'Interne'), 3),
                                                (comment.validationTaskId)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_124, [...(_cache[83] || (_cache[83] = [
                                                      _createElementVNode("i", { class: "fas fa-tasks me-1" }, null, -1),
                                                      _createTextVNode(" Tâche de validation ", -1)
                                                    ]))]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("strong", _hoisted_125, _toDisplayString(comment.author?.username), 1),
                                                _createElementVNode("small", _hoisted_126, _toDisplayString(_ctx.formatDateTime(comment.createdAt)), 1)
                                              ]),
                                              _createElementVNode("p", _hoisted_127, _toDisplayString(comment.commentText), 1),
                                              (comment.validationTask)
                                                ? (_openBlock(), _createElementBlock("small", _hoisted_128, [
                                                    _cache[84] || (_cache[84] = _createElementVNode("i", { class: "fas fa-link me-1" }, null, -1)),
                                                    _createTextVNode(" Lié à : " + _toDisplayString(comment.validationTask.task_name), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_129, [
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (_ctx.editComment(comment)),
                                                class: "btn btn-sm btn-outline-primary"
                                              }, [...(_cache[85] || (_cache[85] = [
                                                _createElementVNode("i", { class: "flaticon-edit" }, null, -1)
                                              ]))], 8, _hoisted_130),
                                              _createElementVNode("button", {
                                                onClick: ($event: any) => (_ctx.deleteComment(comment.id)),
                                                class: "btn btn-sm btn-outline-danger"
                                              }, [...(_cache[86] || (_cache[86] = [
                                                _createElementVNode("i", { class: "flaticon-delete" }, null, -1)
                                              ]))], 8, _hoisted_131)
                                            ])
                                          ])
                                        ], 2))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (bl.comment)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                                      _createElementVNode("div", _hoisted_133, [
                                        _cache[89] || (_cache[89] = _createElementVNode("i", { class: "fas fa-comment-alt fa-lg me-2 mt-1" }, null, -1)),
                                        _createElementVNode("div", _hoisted_134, [
                                          _cache[88] || (_cache[88] = _createElementVNode("strong", null, "Commentaire du contrôleur :", -1)),
                                          _createElementVNode("p", _hoisted_135, _toDisplayString(bl.comment), 1)
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_136, [
                                  _createElementVNode("table", _hoisted_137, [
                                    _cache[90] || (_cache[90] = _createElementVNode("thead", {
                                      style: {"background-color":"#0a59a4"},
                                      class: "text-white"
                                    }, [
                                      _createElementVNode("tr", null, [
                                        _createElementVNode("th", null, "Description"),
                                        _createElementVNode("th", { class: "text-center" }, "Qté"),
                                        _createElementVNode("th", { class: "text-center" }, "Nb Colis"),
                                        _createElementVNode("th", { class: "text-end" }, "Val. comm."),
                                        _createElementVNode("th", { class: "text-end" }, "Val. déclarée"),
                                        _createElementVNode("th", { class: "text-end" }, "Poids brut"),
                                        _createElementVNode("th", { class: "text-end" }, "Poids net"),
                                        _createElementVNode("th", { class: "text-end" }, "Volume")
                                      ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bl.bescLignes, (ligne) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: ligne.id
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(ligne.descriptionMarchandise || '-'), 1),
                                          _createElementVNode("td", _hoisted_138, _toDisplayString(ligne.quantite || '-'), 1),
                                          _createElementVNode("td", _hoisted_139, _toDisplayString(ligne.nombreColis || '-'), 1),
                                          _createElementVNode("td", _hoisted_140, _toDisplayString(_ctx.formatNumber(ligne.valeurCommerciale)) + " " + _toDisplayString(ligne.devise || 'USD'), 1),
                                          _createElementVNode("td", _hoisted_141, _toDisplayString(_ctx.formatNumber(ligne.valeurDeclaree)) + " " + _toDisplayString(ligne.devise || 'USD'), 1),
                                          _createElementVNode("td", _hoisted_142, _toDisplayString(_ctx.formatNumber(ligne.poidsBrut)) + " kg", 1),
                                          _createElementVNode("td", _hoisted_143, _toDisplayString(_ctx.formatNumber(ligne.poidsNet)) + " kg", 1),
                                          _createElementVNode("td", _hoisted_144, _toDisplayString(_ctx.formatNumber(ligne.volume)) + " m³", 1)
                                        ]))
                                      }), 128))
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (bl.conteneurs?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.showConteneurs(bl.conteneurs, bl.blNumber)),
                                  class: "btn btn-primary btn-lg"
                                }, [
                                  _cache[91] || (_cache[91] = _createElementVNode("i", { class: "fas fa-box me-2" }, null, -1)),
                                  _createTextVNode(" Voir les " + _toDisplayString(bl.conteneurs.length) + " conteneur(s) ", 1)
                                ], 8, _hoisted_146)
                              ]))
                            : _createCommentVNode("", true),
                          (!bl.bescLignes?.length && !bl.conteneurs?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_147, [...(_cache[92] || (_cache[92] = [
                                _createElementVNode("i", { class: "fas fa-inbox fa-2x mb-2 opacity-50" }, null, -1),
                                _createElementVNode("p", { class: "mb-0" }, "Aucune marchandise ni conteneur pour ce BL.", -1)
                              ]))]))
                            : _createCommentVNode("", true)
                        ])
                      ], 10, _hoisted_114)
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_148, [...(_cache[93] || (_cache[93] = [
                _createElementVNode("i", { class: "fas fa-inbox fa-3x mb-3 opacity-50" }, null, -1),
                _createElementVNode("p", { class: "mb-0" }, "Aucun BL enregistré.", -1)
              ]))])),
          (_ctx.showConteneursModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 12,
                class: "modal-backdrop fade show",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showConteneursModal = false))
              }))
            : _createCommentVNode("", true),
          (_ctx.showConteneursModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                _createElementVNode("div", _hoisted_150, [
                  _createElementVNode("div", _hoisted_151, [
                    _createElementVNode("div", _hoisted_152, [
                      _createElementVNode("h5", _hoisted_153, [
                        _cache[94] || (_cache[94] = _createElementVNode("i", { class: "fas fa-box me-2" }, null, -1)),
                        _createTextVNode(" Conteneurs du BL N° " + _toDisplayString(_ctx.selectedBlNumber), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close btn-close-white",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showConteneursModal = false))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_154, [
                      _createElementVNode("div", _hoisted_155, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedConteneurs, (conteneur, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: conteneur.id,
                            class: "col-md-6"
                          }, [
                            _createElementVNode("div", _hoisted_156, [
                              _createElementVNode("div", _hoisted_157, [
                                _cache[95] || (_cache[95] = _createElementVNode("i", { class: "fas fa-cube me-2" }, null, -1)),
                                _createTextVNode(" Conteneur " + _toDisplayString(index + 1), 1)
                              ]),
                              _createElementVNode("div", _hoisted_158, [
                                _createElementVNode("div", _hoisted_159, [
                                  _cache[96] || (_cache[96] = _createElementVNode("label", { class: "text-muted small fw-semibold d-block mb-1" }, [
                                    _createElementVNode("i", { class: "fas fa-barcode me-1" }),
                                    _createTextVNode("Numéro de conteneur ")
                                  ], -1)),
                                  _createElementVNode("p", _hoisted_160, _toDisplayString(conteneur.numeroConteneur || 'Non renseigné'), 1)
                                ]),
                                _createElementVNode("div", _hoisted_161, [
                                  _createElementVNode("div", _hoisted_162, [
                                    _cache[97] || (_cache[97] = _createElementVNode("label", { class: "text-muted small fw-semibold d-block mb-1" }, [
                                      _createElementVNode("i", { class: "fas fa-lock me-1" }),
                                      _createTextVNode("N° Scellé ")
                                    ], -1)),
                                    (conteneur.numeroScelle)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_163, _toDisplayString(conteneur.numeroScelle), 1))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_164, " Non renseigné "))
                                  ]),
                                  _createElementVNode("div", _hoisted_165, [
                                    _cache[98] || (_cache[98] = _createElementVNode("label", { class: "text-muted small fw-semibold d-block mb-1" }, [
                                      _createElementVNode("i", { class: "fas fa-weight-hanging me-1" }),
                                      _createTextVNode("Poids brut ")
                                    ], -1)),
                                    (conteneur.poidsBrut)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_166, _toDisplayString(_ctx.formatNumber(conteneur.poidsBrut)) + " kg ", 1))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_167, " Non renseigné "))
                                  ]),
                                  _createElementVNode("div", _hoisted_168, [
                                    _cache[99] || (_cache[99] = _createElementVNode("label", { class: "text-muted small fw-semibold d-block mb-1" }, [
                                      _createElementVNode("i", { class: "fas fa-cube me-1" }),
                                      _createTextVNode("Volume ")
                                    ], -1)),
                                    (conteneur.volume)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_169, _toDisplayString(_ctx.formatNumber(conteneur.volume)) + " m³ ", 1))
                                      : (_openBlock(), _createElementBlock("p", _hoisted_170, " Non renseigné "))
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_171, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showConteneursModal = false))
                      }, [...(_cache[100] || (_cache[100] = [
                        _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1),
                        _createTextVNode(" Fermer ", -1)
                      ]))])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.showCommentFormModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_172, [
                _createElementVNode("div", _hoisted_173, [
                  _createElementVNode("div", _hoisted_174, [
                    _createElementVNode("div", _hoisted_175, [
                      _createElementVNode("h5", _hoisted_176, [
                        _cache[101] || (_cache[101] = _createElementVNode("i", { class: "fas fa-comment-dots me-2" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.editingCommentId ? 'Modifier le commentaire' : 'Nouveau commentaire'), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close btn-close-white",
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeCommentFormModal && _ctx.closeCommentFormModal(...args)))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_177, [
                      _createElementVNode("div", _hoisted_178, [
                        _cache[102] || (_cache[102] = _createElementVNode("i", { class: "fas fa-info-circle me-2" }, null, -1)),
                        _cache[103] || (_cache[103] = _createElementVNode("strong", null, "Contexte :", -1)),
                        (_ctx.commentForm.related_entity_type === 'BESC_FILE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_179, " Commentaire global sur le dossier BESC "))
                          : (_ctx.commentForm.related_entity_type === 'BILL_OF_LADING')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_180, " Commentaire sur le BL N° " + _toDisplayString(_ctx.selectedBl?.blNumber), 1))
                            : (_ctx.commentForm.related_entity_type === 'SUPPORTING_DOCUMENT')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_181, " Commentaire sur un document justificatif "))
                              : _createCommentVNode("", true),
                        (_ctx.commentForm.validation_task_id)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_182, " Lié à une tâche de validation "))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.validationTasks.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                            _cache[104] || (_cache[104] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                              _createElementVNode("i", { class: "fas fa-tasks me-2" }),
                              _createTextVNode("Tâche de validation associée (optionnel) ")
                            ], -1)),
                            _createVNode(_component_Multiselect, {
                              modelValue: _ctx.commentForm.validation_task_id,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.commentForm.validation_task_id) = $event)),
                              options: _ctx.taskOptions,
                              label: "label",
                              "track-by": "value",
                              "value-prop": "value",
                              placeholder: "Aucune tâche (commentaire général)",
                              searchable: true,
                              "allow-empty": true,
                              "close-on-select": true
                            }, null, 8, ["modelValue", "options"]),
                            _cache[105] || (_cache[105] = _createElementVNode("small", { class: "text-muted" }, " Si ce commentaire concerne une tâche de validation spécifique, sélectionnez-la ici ", -1))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_184, [
                        _cache[106] || (_cache[106] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
                          _createElementVNode("i", { class: "fas fa-eye me-2" }),
                          _createTextVNode("Visibilité ")
                        ], -1)),
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.commentForm.visibility,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.commentForm.visibility) = $event)),
                          options: _ctx.visibiliteOptions,
                          label: "label",
                          "track-by": "value",
                          "value-prop": "value",
                          placeholder: "Sélectionner la visibilité",
                          searchable: false,
                          "allow-empty": false
                        }, null, 8, ["modelValue", "options"]),
                        _createElementVNode("small", _hoisted_185, [
                          (_ctx.commentForm.visibility === 'INTERNAL')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_186, " Ce commentaire ne sera visible que par les agents "))
                            : (_openBlock(), _createElementBlock("span", _hoisted_187, " Ce commentaire sera visible par le transitaire/chargeur "))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_188, [
                        _cache[107] || (_cache[107] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Commentaire *", -1)),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.commentForm.comment_text) = $event)),
                          class: "form-control",
                          rows: "6",
                          placeholder: "Saisissez votre commentaire..."
                        }, null, 512), [
                          [_vModelText, _ctx.commentForm.comment_text]
                        ]),
                        _createElementVNode("small", _hoisted_189, _toDisplayString(_ctx.commentForm.comment_text.length) + " caractères ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_190, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeCommentFormModal && _ctx.closeCommentFormModal(...args)))
                      }, [...(_cache[108] || (_cache[108] = [
                        _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1),
                        _createTextVNode(" Annuler ", -1)
                      ]))]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-primary",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.saveComment && _ctx.saveComment(...args)))
                      }, [
                        _cache[109] || (_cache[109] = _createElementVNode("i", { class: "fas fa-save me-2" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.editingCommentId ? 'Mettre à jour' : 'Enregistrer'), 1)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_191, [
            _createElementVNode("h5", _hoisted_192, " Documents joints (" + _toDisplayString(_ctx.besc.documents?.length || 0) + ") ", 1)
          ]),
          (_ctx.besc.documents?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.besc.documents, (doc) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-4",
                    key: doc.id
                  }, [
                    _createElementVNode("div", _hoisted_194, [
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString(doc.typeDocument?.libelle || 'Document'), 1),
                        _cache[110] || (_cache[110] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("small", _hoisted_195, _toDisplayString(doc.filename), 1)
                      ]),
                      _createElementVNode("div", _hoisted_196, [
                        _createElementVNode("button", {
                          class: "btn btn-sm btn-primary",
                          onClick: ($event: any) => (_ctx.openDocumentModal(_ctx.bescId, doc.id, doc.filename))
                        }, [...(_cache[111] || (_cache[111] = [
                          _createElementVNode("i", { class: "fas fa-eye me-1" }, null, -1),
                          _createTextVNode("Voir ", -1)
                        ]))], 8, _hoisted_197),
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.openDocumentCommentModal(doc.id)),
                          class: "btn btn-sm btn-outline-secondary"
                        }, [...(_cache[112] || (_cache[112] = [
                          _createElementVNode("i", { class: "flaticon-comment lh-1 position-relative top-1" }, null, -1)
                        ]))], 8, _hoisted_198)
                      ])
                    ]),
                    (_ctx.getDocumentComments(doc.id).length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_199, [
                          _createElementVNode("small", _hoisted_200, [
                            _cache[113] || (_cache[113] = _createElementVNode("i", { class: "fas fa-comments me-1" }, null, -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.getDocumentComments(doc.id).length) + " commentaire(s) ", 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDocumentComments(doc.id), (comment) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: comment.id,
                              class: _normalizeClass(["small p-2 rounded mb-1", comment.visibility === 'EXTERNAL' ? 'bg-warning bg-opacity-10' : 'bg-light'])
                            }, [
                              _createElementVNode("div", _hoisted_201, [
                                _createElementVNode("strong", null, _toDisplayString(comment.author?.username), 1),
                                _createElementVNode("div", null, [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.editComment(comment)),
                                    class: "btn btn-sm btn-link p-0 me-1"
                                  }, [...(_cache[114] || (_cache[114] = [
                                    _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                                  ]))], 8, _hoisted_202),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.deleteComment(comment.id)),
                                    class: "btn btn-sm btn-link p-0 text-danger"
                                  }, [...(_cache[115] || (_cache[115] = [
                                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                                  ]))], 8, _hoisted_203)
                                ])
                              ]),
                              _createElementVNode("p", _hoisted_204, _toDisplayString(comment.commentText), 1)
                            ], 2))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_205, "Aucun document joint.")),
          (_ctx.showDocumentModal)
            ? (_openBlock(), _createElementBlock("div", {
                key: 17,
                class: "modal-backdrop fade show",
                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeDocumentModal && _ctx.closeDocumentModal(...args)))
              }))
            : _createCommentVNode("", true),
          (_ctx.showDocumentModal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                _createElementVNode("div", _hoisted_207, [
                  _createElementVNode("div", _hoisted_208, [
                    _createElementVNode("div", _hoisted_209, [
                      _createElementVNode("h5", _hoisted_210, [
                        _cache[116] || (_cache[116] = _createElementVNode("i", { class: "fas fa-file me-2" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.currentDocumentName), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-close btn-close-white",
                        onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeDocumentModal && _ctx.closeDocumentModal(...args)))
                      })
                    ]),
                    _createElementVNode("div", _hoisted_211, [
                      (_ctx.loadingDocument)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_212, [...(_cache[117] || (_cache[117] = [
                            _createElementVNode("div", {
                              class: "spinner-border text-light mb-3",
                              role: "status"
                            }, null, -1),
                            _createElementVNode("p", null, "Chargement du document...", -1)
                          ]))]))
                        : (_ctx.currentDocumentUrl && _ctx.currentDocumentType === 'pdf')
                          ? (_openBlock(), _createElementBlock("iframe", {
                              key: 1,
                              src: _ctx.currentDocumentUrl,
                              style: {"width":"100%","height":"100%","border":"none"}
                            }, null, 8, _hoisted_213))
                          : (_ctx.currentDocumentUrl && _ctx.currentDocumentType === 'image')
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 2,
                                src: _ctx.currentDocumentUrl,
                                style: {"max-width":"100%","max-height":"100%","object-fit":"contain"}
                              }, null, 8, _hoisted_214))
                            : (_openBlock(), _createElementBlock("div", _hoisted_215, [...(_cache[118] || (_cache[118] = [
                                _createElementVNode("i", { class: "fas fa-file fa-4x mb-3 opacity-50" }, null, -1),
                                _createElementVNode("p", null, "Ce type de fichier ne peut pas être prévisualisé.", -1)
                              ]))]))
                    ]),
                    _createElementVNode("div", _hoisted_216, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary",
                        onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeDocumentModal && _ctx.closeDocumentModal(...args)))
                      }, [...(_cache[119] || (_cache[119] = [
                        _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1),
                        _createTextVNode("Fermer ", -1)
                      ]))])
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_217, " Aucun document joint. ")),
          _cache[179] || (_cache[179] = _createElementVNode("div", { class: "mb-4 mt-5" }, [
            _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, "Historique des statuts")
          ], -1)),
          _createElementVNode("div", _hoisted_218, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusHistory, (h, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: h.id,
                class: "timeline-item"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["timeline-marker", index === 0 ? 'bg-success' : 'bg-primary'])
                }, null, 2),
                _createElementVNode("div", _hoisted_219, [
                  _createElementVNode("p", _hoisted_220, [
                    _createTextVNode(_toDisplayString(h.newStatus?.label || 'Statut inconnu') + " ", 1),
                    _createElementVNode("span", _hoisted_221, "— " + _toDisplayString(_ctx.formatDateTime(h.createdAt)), 1)
                  ]),
                  _createElementVNode("p", _hoisted_222, [
                    _createTextVNode(" Par : " + _toDisplayString(h.changedByUser?.username || 'Système'), 1),
                    _cache[120] || (_cache[120] = _createElementVNode("br", null, null, -1)),
                    _createTextVNode(" Motif : " + _toDisplayString(h.changeReason || '-') + " ", 1),
                    (h.comment)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_223, "• " + _toDisplayString(h.comment), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            }), 128))
          ]),
          (_ctx.autoFlags.length > 0 || _ctx.appliedRules.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_224, [...(_cache[121] || (_cache[121] = [
                _createElementVNode("h5", { class: "text-primary fw-bold border-bottom pb-2" }, [
                  _createElementVNode("i", { class: "fas fa-cogs me-2" }),
                  _createTextVNode(" Règles appliquées — Moments d'exécution ")
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          (_ctx.appliedRules.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_225, [
                _createElementVNode("div", _hoisted_226, [
                  _createElementVNode("table", _hoisted_227, [
                    _cache[122] || (_cache[122] = _createElementVNode("thead", {
                      style: {"background-color":"#0a59a4"},
                      class: "text-white"
                    }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, "Code"),
                        _createElementVNode("th", null, "Libellé"),
                        _createElementVNode("th", null, "Sévérité"),
                        _createElementVNode("th", { class: "text-center" }, "À la création"),
                        _createElementVNode("th", { class: "text-center" }, "À la mise à jour"),
                        _createElementVNode("th", { class: "text-center" }, "Avant émission"),
                        _createElementVNode("th", null, "Pays")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.appliedRules, (rule) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: rule.id
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("code", _hoisted_228, _toDisplayString(rule.code), 1)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(rule.name), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", _ctx.getSeverityBadgeClass(rule.severity)])
                            }, _toDisplayString(_ctx.translateSeverity(rule.severity)), 3)
                          ]),
                          _createElementVNode("td", _hoisted_229, [
                            (rule.run_on_creation)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_230))
                              : (_openBlock(), _createElementBlock("i", _hoisted_231))
                          ]),
                          _createElementVNode("td", _hoisted_232, [
                            (rule.run_on_update)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_233))
                              : (_openBlock(), _createElementBlock("i", _hoisted_234))
                          ]),
                          _createElementVNode("td", _hoisted_235, [
                            (rule.run_on_pre_issuance)
                              ? (_openBlock(), _createElementBlock("i", _hoisted_236))
                              : (_openBlock(), _createElementBlock("i", _hoisted_237))
                          ]),
                          _createElementVNode("td", null, [
                            (rule.country_code && rule.country_code !== 'ALL')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_238, _toDisplayString(rule.country_code), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_239, "Global"))
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_240, [...(_cache[123] || (_cache[123] = [
                  _createElementVNode("i", { class: "fas fa-cogs fa-2x text-muted mb-2" }, null, -1),
                  _createElementVNode("p", { class: "mb-0 text-muted" }, "Aucune règle configurée pour ce dossier", -1)
                ]))]))
              : _createCommentVNode("", true),
          (_ctx.validationTasks.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_241, [
                _createElementVNode("div", _hoisted_242, [
                  _createElementVNode("div", _hoisted_243, [
                    _createElementVNode("div", _hoisted_244, [
                      _cache[124] || (_cache[124] = _createElementVNode("h6", { class: "mb-0 fw-bold" }, [
                        _createElementVNode("i", { class: "fas fa-chart-line me-2 text-primary" }),
                        _createTextVNode(" Progression globale des vérifications ")
                      ], -1)),
                      _createElementVNode("span", _hoisted_245, _toDisplayString(_ctx.globalProgressionStats.passedCount) + "/" + _toDisplayString(_ctx.globalProgressionStats.totalChecks) + " conformes ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_246, [
                      (_ctx.globalProgressionStats.passedPercentage > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "progress-bar bg-success d-flex align-items-center justify-content-center fw-bold",
                            style: _normalizeStyle({ width: _ctx.globalProgressionStats.passedPercentage + '%' })
                          }, _toDisplayString(_ctx.globalProgressionStats.passedPercentage) + "% ", 5))
                        : _createCommentVNode("", true),
                      (_ctx.globalProgressionStats.warningPercentage > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "progress-bar bg-warning d-flex align-items-center justify-content-center fw-bold text-dark",
                            style: _normalizeStyle({ width: _ctx.globalProgressionStats.warningPercentage + '%' })
                          }, _toDisplayString(_ctx.globalProgressionStats.warningPercentage) + "% ", 5))
                        : _createCommentVNode("", true),
                      (_ctx.globalProgressionStats.failedPercentage > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "progress-bar bg-danger d-flex align-items-center justify-content-center fw-bold text-white",
                            style: _normalizeStyle({ width: _ctx.globalProgressionStats.failedPercentage + '%' })
                          }, _toDisplayString(_ctx.globalProgressionStats.failedPercentage) + "% ", 5))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_247, [
                      _createElementVNode("div", _hoisted_248, [
                        _cache[125] || (_cache[125] = _createElementVNode("div", {
                          class: "bg-success",
                          style: {"width":"16px","height":"16px","border-radius":"3px"}
                        }, null, -1)),
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.globalProgressionStats.passedCount), 1),
                          _createTextVNode(" Conforme(s) (" + _toDisplayString(_ctx.globalProgressionStats.passedPercentage) + "%)", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_249, [
                        _cache[126] || (_cache[126] = _createElementVNode("div", {
                          class: "bg-warning",
                          style: {"width":"16px","height":"16px","border-radius":"3px"}
                        }, null, -1)),
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.globalProgressionStats.warningCount), 1),
                          _createTextVNode(" Avertissement(s) (" + _toDisplayString(_ctx.globalProgressionStats.warningPercentage) + "%)", 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_250, [
                        _cache[127] || (_cache[127] = _createElementVNode("div", {
                          class: "bg-danger",
                          style: {"width":"16px","height":"16px","border-radius":"3px"}
                        }, null, -1)),
                        _createElementVNode("span", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.globalProgressionStats.failedCount), 1),
                          _createTextVNode(" Non conforme(s) (" + _toDisplayString(_ctx.globalProgressionStats.failedPercentage) + "%)", 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.pendingCorrections.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_251, [
                _createElementVNode("div", _hoisted_252, [
                  _createElementVNode("div", _hoisted_253, [
                    _cache[131] || (_cache[131] = _createElementVNode("i", { class: "fas fa-clipboard-check fa-2x text-primary" }, null, -1)),
                    _createElementVNode("div", null, [
                      _cache[129] || (_cache[129] = _createElementVNode("h5", { class: "mb-1 fw-bold text-primary" }, [
                        _createElementVNode("i", { class: "flaticon-check-mark me-2" }),
                        _createTextVNode(" Corrections en attente ")
                      ], -1)),
                      _createElementVNode("p", _hoisted_254, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.pendingCorrections.length) + " correction(s)", 1),
                        _cache[128] || (_cache[128] = _createTextVNode(" en attente de traitement ", -1))
                      ]),
                      _cache[130] || (_cache[130] = _createElementVNode("small", { class: "text-muted" }, " Marquez les corrections comme résolues une fois traitées ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_255, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingCorrections, (correction) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: correction.id,
                        class: "d-flex align-items-center justify-content-between p-2 mb-2 bg-light rounded"
                      }, [
                        _createElementVNode("div", _hoisted_256, [
                          _createElementVNode("small", _hoisted_257, _toDisplayString(correction.fields_concerned), 1),
                          _createElementVNode("p", _hoisted_258, _toDisplayString(correction.message_to_requester), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.allCorrections.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_259, [
                _createElementVNode("div", _hoisted_260, [
                  _createElementVNode("div", _hoisted_261, [
                    _cache[135] || (_cache[135] = _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-2x text-primary" }, null, -1)),
                    _createElementVNode("div", null, [
                      _cache[133] || (_cache[133] = _createElementVNode("h5", { class: "mb-1 fw-bold text-primary" }, " Nouvelles corrections détectées ", -1)),
                      _createElementVNode("p", _hoisted_262, [
                        _createElementVNode("strong", null, _toDisplayString(_ctx.allCorrections.length) + " correction(s)", 1),
                        _cache[132] || (_cache[132] = _createTextVNode(" détectée(s) lors des vérifications ", -1))
                      ]),
                      _cache[134] || (_cache[134] = _createElementVNode("small", { class: "text-muted" }, " Envoyez ces corrections au transitaire pour traitement ", -1))
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showCorrectionRequestModal = true)),
                    class: "btn btn-primary btn-lg px-2"
                  }, [
                    _cache[136] || (_cache[136] = _createElementVNode("i", { class: "fas fa-paper-plane me-2" }, null, -1)),
                    _createTextVNode(" Envoyer " + _toDisplayString(_ctx.allCorrections.length) + " correction(s) ", 1)
                  ])
                ])
              ]))
            : (_ctx.allCorrections.length === 0 && _ctx.validationTasks.length > 0 && _ctx.allTasksCompleted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_263, [...(_cache[137] || (_cache[137] = [
                  _createStaticVNode("<div class=\"d-flex align-items-center gap-3\" data-v-4374ec8f><i class=\"fas fa-check-circle fa-2x text-success\" data-v-4374ec8f></i><div data-v-4374ec8f><h5 class=\"mb-1 fw-bold text-success\" data-v-4374ec8f><i class=\"flaticon-paper-plane me-2\" data-v-4374ec8f></i> Dossier conforme </h5><p class=\"mb-0\" data-v-4374ec8f> Toutes les vérifications sont terminées et aucune correction n&#39;est nécessaire </p></div></div>", 1)
                ]))]))
              : _createCommentVNode("", true),
          (_ctx.validationTasks.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_264, [
                _createElementVNode("h5", _hoisted_265, [
                  _cache[138] || (_cache[138] = _createElementVNode("i", { class: "fas fa-tasks me-2" }, null, -1)),
                  _createTextVNode(" Tâches de validation (" + _toDisplayString(_ctx.validationTasks.length) + ") ", 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.validationTasks.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                _createElementVNode("div", _hoisted_267, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationTasks, (task, taskIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: task.id,
                      class: "accordion-item border mb-3 shadow-sm"
                    }, [
                      _createElementVNode("h2", _hoisted_268, [
                        _createElementVNode("button", {
                          class: "accordion-button collapsed bg-white",
                          type: "button",
                          "data-bs-toggle": 'collapse',
                          "data-bs-target": '#task' + taskIndex,
                          "aria-expanded": false,
                          "aria-controls": 'task' + taskIndex
                        }, [
                          _createElementVNode("div", _hoisted_270, [
                            _createElementVNode("div", null, [
                              _cache[139] || (_cache[139] = _createElementVNode("i", { class: "flaticon-task me-2" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(task.libelle || 'Tâche sans titre'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_271, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["badge", {
                        'bg-success': task.status === 'COMPLETED',
                        'bg-warning text-dark': task.status === 'IN_PROGRESS',
                        'bg-secondary': task.status === 'PENDING'
                      }])
                              }, _toDisplayString(_ctx.translateStatus(task.status)), 3),
                              (task.checks?.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_272, _toDisplayString(_ctx.getCheckStats(task.checks)?.completion || 0) + "% complété ", 1))
                                : _createCommentVNode("", true),
                              (_ctx.getTaskComments(task.id).length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_273, [
                                    _cache[140] || (_cache[140] = _createElementVNode("i", { class: "fas fa-comments me-1" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.getTaskComments(task.id).length), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 8, _hoisted_269)
                      ]),
                      _createElementVNode("div", {
                        id: 'task' + taskIndex,
                        class: "accordion-collapse collapse",
                        "data-bs-parent": "#tasksAccordion"
                      }, [
                        _createElementVNode("div", _hoisted_275, [
                          _createElementVNode("div", _hoisted_276, [
                            _createElementVNode("div", _hoisted_277, [
                              _cache[142] || (_cache[142] = _createElementVNode("label", { class: "text-muted small fw-semibold" }, "Assigné à", -1)),
                              _createElementVNode("p", _hoisted_278, [
                                _cache[141] || (_cache[141] = _createElementVNode("i", { class: "fas fa-user me-1 text-primary" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(task.user ? `${task.user.nom} ${task.user.prenom}` : 'Aucun agent assigné'), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_279, [
                              _cache[144] || (_cache[144] = _createElementVNode("label", { class: "text-muted small fw-semibold" }, "Date limite (SLA)", -1)),
                              _createElementVNode("p", _hoisted_280, [
                                _cache[143] || (_cache[143] = _createElementVNode("i", { class: "fas fa-calendar-alt me-1 text-primary" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(task.sla_due_at ? _ctx.formatDate(task.sla_due_at) : 'Non définie'), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_281, [
                              _cache[145] || (_cache[145] = _createElementVNode("label", { class: "text-muted small fw-semibold" }, "Priorité", -1)),
                              _createElementVNode("p", _hoisted_282, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", {
                          'bg-danger': task.priority === 'HIGH',
                          'bg-warning text-dark': task.priority === 'MEDIUM',
                          'bg-info': task.priority === 'LOW'
                        }])
                                }, _toDisplayString(task.priority === 'HIGH' ? 'Haute' : task.priority === 'MEDIUM' ? 'Moyenne' : 'Basse'), 3)
                              ])
                            ]),
                            (task.description)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_283, [
                                  _cache[146] || (_cache[146] = _createElementVNode("label", { class: "text-muted small fw-semibold" }, "Description", -1)),
                                  _createElementVNode("p", _hoisted_284, _toDisplayString(task.description), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (task.checks?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_285, [
                                _createElementVNode("div", _hoisted_286, [
                                  _cache[147] || (_cache[147] = _createElementVNode("label", { class: "text-muted small fw-semibold" }, [
                                    _createElementVNode("i", { class: "fas fa-chart-line me-1" }),
                                    _createTextVNode(" Progression des contrôles ")
                                  ], -1)),
                                  _createElementVNode("small", _hoisted_287, _toDisplayString(_ctx.getTaskProgress(task).completed) + " / " + _toDisplayString(_ctx.getTaskProgress(task).total) + " traités ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_288, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["progress-bar progress-bar-striped", {
                        'bg-success': _ctx.getTaskProgress(task).percentage === 100,
                        'bg-warning': _ctx.getTaskProgress(task).percentage > 0 && _ctx.getTaskProgress(task).percentage < 100,
                        'bg-secondary': _ctx.getTaskProgress(task).percentage === 0
                      }]),
                                    style: _normalizeStyle({ width: _ctx.getTaskProgress(task).percentage + '%' }),
                                    role: "progressbar",
                                    "aria-valuenow": _ctx.getTaskProgress(task).percentage,
                                    "aria-valuemin": "0",
                                    "aria-valuemax": "100"
                                  }, null, 14, _hoisted_289)
                                ]),
                                _createElementVNode("div", _hoisted_290, [
                                  _createElementVNode("small", _hoisted_291, _toDisplayString(_ctx.getTaskProgress(task).percentage) + "% complété", 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (task.checks?.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_292, [
                                _createElementVNode("div", _hoisted_293, [
                                  _createElementVNode("h6", _hoisted_294, [
                                    _cache[148] || (_cache[148] = _createElementVNode("i", { class: "fas fa-clipboard-check me-2 text-primary" }, null, -1)),
                                    _createTextVNode(" Check-list de validation (" + _toDisplayString(task.checks.length) + ") ", 1)
                                  ]),
                                  (_ctx.getCheckStats(task.checks))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_295, [
                                        _createElementVNode("span", _hoisted_296, [
                                          _cache[149] || (_cache[149] = _createElementVNode("i", { class: "fas fa-check me-1" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.getCheckStats(task.checks)?.passed ?? 0) + " Conforme(s) ", 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_297, [
                                          _cache[150] || (_cache[150] = _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.getCheckStats(task.checks)?.failed ?? 0) + " Non conforme(s) ", 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_298, [
                                          _cache[151] || (_cache[151] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.getCheckStats(task.checks)?.warning ?? 0) + " Avertissement(s) ", 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_299, [
                                          _cache[152] || (_cache[152] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1)),
                                          _createTextVNode(" " + _toDisplayString(_ctx.getCheckStats(task.checks)?.pending ?? 0) + " En attente ", 1)
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (task.status === 'COMPLETED')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_300, [...(_cache[153] || (_cache[153] = [
                                      _createElementVNode("i", { class: "flaticon-lock me-2" }, null, -1),
                                      _createTextVNode(" Cette tâche est terminée. Les contrôles ne peuvent plus être modifiés. ", -1)
                                    ]))]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_301, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(task.checks, (check, checkIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: check.id,
                                      class: "col-lg-6"
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["card h-100 shadow-sm check-card", {
                          'border-success border-2': check.result === 'PASSED',
                          'border-danger border-2': check.result === 'FAILED',
                          'border-warning border-2': check.result === 'WARNING',
                          'border-secondary': check.result === 'PENDING',
                          'border-info border-2': check.result === 'NOT_APPLICABLE'
                        }])
                                      }, [
                                        _createElementVNode("div", _hoisted_302, [
                                          _createElementVNode("div", _hoisted_303, [
                                            _createElementVNode("div", _hoisted_304, [
                                              _createElementVNode("span", _hoisted_305, _toDisplayString(Number(checkIndex) + 1), 1),
                                              _createElementVNode("div", _hoisted_306, [
                                                _createElementVNode("h6", _hoisted_307, [
                                                  _createElementVNode("i", {
                                                    class: _normalizeClass([
                                      _ctx.getCheckResultIcon(check.result),
                                      'me-2',
                                      {
                                        'text-success': check.result === 'PASSED',
                                        'text-danger': check.result === 'FAILED',
                                        'text-warning': check.result === 'WARNING',
                                        'text-secondary': check.result === 'PENDING',
                                        'text-info': check.result === 'NOT_APPLICABLE'
                                      }
                                    ])
                                                  }, null, 2),
                                                  _createTextVNode(" " + _toDisplayString(check.title), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_308, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["badge small", check.check_type === 'MANUAL' ? 'bg-primary' : 'bg-info'])
                                                  }, [
                                                    _createElementVNode("i", {
                                                      class: _normalizeClass(check.check_type === 'MANUAL' ? 'fas fa-user' : 'fas fa-robot')
                                                    }, null, 2),
                                                    _createTextVNode(" " + _toDisplayString(check.check_type === 'MANUAL' ? 'Manuel' : 'Automatique'), 1)
                                                  ], 2),
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass(["badge small", _ctx.getSeverityBadgeClass(check.severity)])
                                                  }, [
                                                    _cache[154] || (_cache[154] = _createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1)),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.translateSeverity(check.severity)), 1)
                                                  ], 2),
                                                  (check.check_code)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_309, _toDisplayString(check.check_code), 1))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("p", _hoisted_310, _toDisplayString(check.description || 'Aucune description'), 1)
                                              ])
                                            ]),
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["badge fs-6 px-3 py-2", _ctx.getCheckResultClass(check.result)])
                                            }, _toDisplayString(_ctx.translateStatus(check.result)), 3)
                                          ]),
                                          _createElementVNode("div", _hoisted_311, [
                                            ((check.result === 'FAILED' || check.result === 'WARNING') &&
                                (!check.comments || check.comments.trim() === ''))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_312, [...(_cache[155] || (_cache[155] = [
                                                  _createElementVNode("i", { class: "fas fa-exclamation-circle me-1" }, null, -1),
                                                  _createElementVNode("strong", null, "Commentaire obligatoire !", -1),
                                                  _createElementVNode("small", { class: "d-block mt-1" }, " Un commentaire est requis pour expliquer cette non-conformité au transitaire. ", -1)
                                                ]))]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_313, [
                                              _createElementVNode("label", _hoisted_314, [
                                                _cache[157] || (_cache[157] = _createElementVNode("i", { class: "fas fa-check-circle me-1" }, null, -1)),
                                                _cache[158] || (_cache[158] = _createTextVNode(" Résultat du contrôle ", -1)),
                                                (check.check_type === 'AUTOMATIC')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_315, [...(_cache[156] || (_cache[156] = [
                                                      _createElementVNode("i", { class: "fas fa-robot me-1" }, null, -1),
                                                      _createTextVNode(" Automatique ", -1)
                                                    ]))]))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _createVNode(_component_Multiselect, {
                                                "model-value": check.result,
                                                "onUpdate:modelValue": (newValue) => _ctx.updateCheck(task.id, check.id, newValue, check.comments),
                                                options: _ctx.resultatCheckOptions,
                                                disabled: task.status === 'COMPLETED',
                                                label: "label",
                                                "track-by": "value",
                                                "value-prop": "value",
                                                searchable: false,
                                                "allow-empty": false
                                              }, null, 8, ["model-value", "onUpdate:modelValue", "options", "disabled"])
                                            ]),
                                            _createElementVNode("div", _hoisted_316, [
                                              _cache[159] || (_cache[159] = _createElementVNode("label", { class: "form-label small fw-semibold mb-2" }, [
                                                _createElementVNode("i", { class: "fas fa-comment me-1" }),
                                                _createTextVNode(" Commentaire / Justification ")
                                              ], -1)),
                                              _createElementVNode("textarea", {
                                                class: "form-control form-control-sm",
                                                rows: "3",
                                                value: check.comments,
                                                onBlur: (e) => _ctx.updateCheck(task.id, check.id, check.result, (e.target as HTMLTextAreaElement)?.value || ''),
                                                disabled: task.status === 'COMPLETED',
                                                placeholder: "Ajoutez une justification, remarque ou observation..."
                                              }, null, 40, _hoisted_317),
                                              _createElementVNode("small", _hoisted_318, _toDisplayString(check.comments?.length || 0) + " caractère(s) ", 1)
                                            ]),
                                            (check.checked_at)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_319, [
                                                  _createElementVNode("small", _hoisted_320, [
                                                    _cache[160] || (_cache[160] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1)),
                                                    _cache[161] || (_cache[161] = _createElementVNode("strong", null, "Dernière mise à jour :", -1)),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(check.checked_at)), 1)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ], 2)
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_321, [...(_cache[162] || (_cache[162] = [
                                _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-2x mb-2" }, null, -1),
                                _createElementVNode("p", { class: "mb-0" }, "Aucune vérification configurée pour cette tâche", -1)
                              ]))])),
                          _createElementVNode("div", _hoisted_322, [
                            _createElementVNode("div", _hoisted_323, [
                              _createElementVNode("h6", _hoisted_324, [
                                _cache[163] || (_cache[163] = _createElementVNode("i", { class: "fas fa-comments me-2 text-primary" }, null, -1)),
                                _createTextVNode(" Commentaires sur cette tâche (" + _toDisplayString(_ctx.getTaskComments(task.id).length) + ") ", 1)
                              ]),
                              _createElementVNode("div", _hoisted_325, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.openCommentModalWithTask('BESC_FILE', null, task.id)),
                                  class: "btn btn-sm btn-outline-primary"
                                }, [...(_cache[164] || (_cache[164] = [
                                  _createElementVNode("i", { class: "fas fa-plus me-1" }, null, -1),
                                  _createTextVNode(" Ajouter un commentaire ", -1)
                                ]))], 8, _hoisted_326)
                              ])
                            ]),
                            (_ctx.getTaskComments(task.id).length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_327, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTaskComments(task.id), (comment) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: comment.id,
                                      class: _normalizeClass(["card mb-2 shadow-sm", comment.visibility === 'EXTERNAL' ? 'border-warning' : 'border-secondary'])
                                    }, [
                                      _createElementVNode("div", _hoisted_328, [
                                        _createElementVNode("div", _hoisted_329, [
                                          _createElementVNode("div", null, [
                                            _createElementVNode("span", {
                                              class: _normalizeClass(["badge me-2", comment.visibility === 'EXTERNAL' ? 'bg-warning text-dark' : 'bg-secondary'])
                                            }, [
                                              _createElementVNode("i", {
                                                class: _normalizeClass(comment.visibility === 'EXTERNAL' ? 'fas fa-eye' : 'fas fa-lock')
                                              }, null, 2),
                                              _createTextVNode(" " + _toDisplayString(comment.visibility === 'EXTERNAL' ? 'Externe' : 'Interne'), 1)
                                            ], 2),
                                            (comment.relatedEntityType !== 'BESC_FILE')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_330, [
                                                  _cache[165] || (_cache[165] = _createElementVNode("i", { class: "fas fa-link me-1" }, null, -1)),
                                                  _createTextVNode(" " + _toDisplayString(comment.relatedEntityType === 'BILL_OF_LADING' ? 'BL' :
                                  comment.relatedEntityType === 'SUPPORTING_DOCUMENT' ? 'Document' :
                                    'Autre'), 1)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("strong", null, _toDisplayString(comment.author?.username || 'Utilisateur'), 1),
                                            _createElementVNode("small", _hoisted_331, _toDisplayString(_ctx.formatDateTime(comment.createdAt)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_332, [
                                            _createElementVNode("button", {
                                              onClick: ($event: any) => (_ctx.editComment(comment)),
                                              class: "btn btn-outline-primary",
                                              title: "Modifier"
                                            }, [...(_cache[166] || (_cache[166] = [
                                              _createElementVNode("i", { class: "fas fa-edit" }, null, -1)
                                            ]))], 8, _hoisted_333),
                                            _createElementVNode("button", {
                                              onClick: ($event: any) => (_ctx.deleteComment(comment.id)),
                                              class: "btn btn-outline-danger",
                                              title: "Supprimer"
                                            }, [...(_cache[167] || (_cache[167] = [
                                              _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                                            ]))], 8, _hoisted_334)
                                          ])
                                        ]),
                                        _createElementVNode("p", _hoisted_335, _toDisplayString(comment.commentText), 1)
                                      ])
                                    ], 2))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_336, [...(_cache[168] || (_cache[168] = [
                                  _createElementVNode("i", { class: "fas fa-comment-slash text-muted fa-2x mb-2" }, null, -1),
                                  _createElementVNode("p", { class: "mb-0 text-muted" }, "Aucun commentaire pour cette tâche", -1)
                                ]))]))
                          ]),
                          (task.status !== 'COMPLETED')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_337, [
                                (task.status !== 'COMPLETED')
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: ($event: any) => (_ctx.completeTask(task.id)),
                                      class: "btn btn-success btn-lg px-5",
                                      disabled: !_ctx.getTaskProgress(task).canComplete
                                    }, [...(_cache[169] || (_cache[169] = [
                                      _createElementVNode("i", { class: "fas fa-check-double me-2" }, null, -1),
                                      _createTextVNode(" Marquer comme complétée ", -1)
                                    ]))], 8, _hoisted_338))
                                  : _createCommentVNode("", true),
                                (!_ctx.getTaskProgress(task).canComplete)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_339, [...(_cache[170] || (_cache[170] = [
                                      _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1),
                                      _createTextVNode(" Tous les contrôles doivent être traités avant de finaliser la tâche ", -1)
                                    ]))]))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_340, [
                                _cache[171] || (_cache[171] = _createElementVNode("i", { class: "fas fa-check-circle fa-2x mb-2" }, null, -1)),
                                _cache[172] || (_cache[172] = _createElementVNode("h6", { class: "mb-1" }, "Tâche complétée", -1)),
                                _createElementVNode("small", null, " Le " + _toDisplayString(_ctx.formatDateTime(task.completed_at)), 1)
                              ]))
                        ])
                      ], 8, _hoisted_274)
                    ]))
                  }), 128))
                ])
              ]))
            : (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_341, [...(_cache[173] || (_cache[173] = [
                  _createElementVNode("i", { class: "fas fa-info-circle fa-3x mb-3" }, null, -1),
                  _createElementVNode("h5", null, "Aucune tâche de validation", -1),
                  _createElementVNode("p", { class: "mb-0 text-muted" }, "Ce BESC n'a pas encore de tâches de validation assignées", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_342, [...(_cache[174] || (_cache[174] = [
                  _createElementVNode("div", {
                    class: "spinner-border text-primary",
                    role: "status"
                  }, [
                    _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                  ], -1),
                  _createElementVNode("p", { class: "mt-3 text-muted" }, "Chargement des tâches de validation...", -1)
                ]))])),
          _createElementVNode("div", _hoisted_343, [
            _createVNode(_component_router_link, {
              to: "/liste-besc",
              class: "btn btn-secondary px-4"
            }, {
              default: _withCtx(() => [...(_cache[175] || (_cache[175] = [
                _createTextVNode(" Retour à la liste ", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_344, [
              (_ctx.besc.currentStatus?.code === 'DRAFT')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.goToEdit && _ctx.goToEdit(...args))),
                    class: "btn btn-warning px-4 text-white"
                  }, " Modifier "))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showFlagsModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-backdrop fade show",
          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showFlagsModal = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showFlagsModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_345, [
          _createElementVNode("div", _hoisted_346, [
            _createElementVNode("div", _hoisted_347, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal-header bg-gradient", _ctx.totalBlockingFlags > 0 ? 'bg-white' : 'bg-warning'])
              }, [
                _createElementVNode("div", _hoisted_348, [
                  _cache[183] || (_cache[183] = _createElementVNode("h5", { class: "modal-title mb-2" }, [
                    _createElementVNode("i", { class: "fas fa-clipboard-check me-2" }),
                    _createTextVNode(" Rapport des contrôles automatiques ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_349, [
                    (_ctx.totalBlockingFlags > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_350, [
                          _cache[180] || (_cache[180] = _createElementVNode("i", { class: "fas fa-ban me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.totalBlockingFlags) + " Bloquante(s) ", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.totalHighRiskFlags > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_351, [
                          _cache[181] || (_cache[181] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.totalHighRiskFlags) + " Risque élevé ", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.totalWarningFlags > 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_352, [
                          _cache[182] || (_cache[182] = _createElementVNode("i", { class: "fas fa-info-circle me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.totalWarningFlags) + " Avertissement(s) ", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.showFlagsModal = false))
                })
              ], 2),
              _createElementVNode("div", _hoisted_353, [
                (_ctx.totalBlockingFlags > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_354, [
                      _createElementVNode("div", _hoisted_355, [
                        _cache[184] || (_cache[184] = _createElementVNode("i", { class: "fas fa-ban text-danger fa-lg me-2" }, null, -1)),
                        _createElementVNode("h6", _hoisted_356, " ALERTES BLOQUANTES (" + _toDisplayString(_ctx.totalBlockingFlags) + ") ", 1)
                      ]),
                      _cache[193] || (_cache[193] = _createElementVNode("p", { class: "text-muted small mb-3" }, " Ces anomalies empêchent l'émission du BESC. Elles doivent être résolues par un agent habilité. ", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockingFlags, (flag, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: flag.id,
                          class: "card border-danger mb-3 shadow-sm"
                        }, [
                          _createElementVNode("div", _hoisted_357, [
                            _createElementVNode("div", _hoisted_358, [
                              _createElementVNode("div", _hoisted_359, [
                                _createElementVNode("span", _hoisted_360, _toDisplayString(index + 1), 1),
                                _createElementVNode("div", null, [
                                  _createElementVNode("h6", _hoisted_361, [
                                    _cache[185] || (_cache[185] = _createElementVNode("i", { class: "fas fa-ban me-2" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(flag.title), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_362, _toDisplayString(flag.severity), 1),
                                  _createElementVNode("span", _hoisted_363, _toDisplayString(flag.flag_type), 1)
                                ])
                              ]),
                              _cache[186] || (_cache[186] = _createElementVNode("span", { class: "badge bg-danger" }, "BLOQUANT", -1))
                            ]),
                            _createElementVNode("div", _hoisted_364, [
                              _cache[187] || (_cache[187] = _createElementVNode("strong", null, "Description :", -1)),
                              _cache[188] || (_cache[188] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(flag.description), 1)
                            ]),
                            _createElementVNode("div", _hoisted_365, [
                              _createElementVNode("div", _hoisted_366, [
                                _cache[189] || (_cache[189] = _createElementVNode("i", { class: "fas fa-cogs me-1" }, null, -1)),
                                _cache[190] || (_cache[190] = _createElementVNode("strong", null, "Règle :", -1)),
                                _createTextVNode(" " + _toDisplayString(flag.rule?.name || 'Non spécifiée'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_367, [
                                _cache[191] || (_cache[191] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1)),
                                _cache[192] || (_cache[192] = _createElementVNode("strong", null, "Détecté le :", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(flag.createdAt)), 1)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.totalHighRiskFlags > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_368, [
                      _createElementVNode("div", _hoisted_369, [
                        _cache[194] || (_cache[194] = _createElementVNode("i", { class: "fas fa-exclamation-triangle text-danger fa-lg me-2" }, null, -1)),
                        _createElementVNode("h6", _hoisted_370, " RISQUES ÉLEVÉS - BLOQUANTS (" + _toDisplayString(_ctx.totalHighRiskFlags) + ") ", 1)
                      ]),
                      _cache[203] || (_cache[203] = _createElementVNode("p", { class: "text-muted small mb-3" }, [
                        _createTextVNode(" Ces alertes signalent des risques élevés qui "),
                        _createElementVNode("strong", null, "empêchent également l'émission du BESC"),
                        _createTextVNode(". Elles nécessitent une validation obligatoire. ")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.highRiskFlags, (flag, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: flag.id,
                          class: "card border-danger mb-3 shadow-sm"
                        }, [
                          _createElementVNode("div", _hoisted_371, [
                            _createElementVNode("div", _hoisted_372, [
                              _createElementVNode("div", _hoisted_373, [
                                _createElementVNode("span", _hoisted_374, _toDisplayString(_ctx.totalBlockingFlags + index + 1), 1),
                                _createElementVNode("div", null, [
                                  _createElementVNode("h6", _hoisted_375, [
                                    _cache[195] || (_cache[195] = _createElementVNode("i", { class: "fas fa-exclamation-triangle me-2" }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(flag.title), 1)
                                  ]),
                                  _createElementVNode("span", _hoisted_376, _toDisplayString(flag.severity), 1),
                                  _createElementVNode("span", _hoisted_377, _toDisplayString(flag.flag_type), 1)
                                ])
                              ]),
                              _cache[196] || (_cache[196] = _createElementVNode("span", { class: "badge bg-danger" }, "BLOQUANT", -1))
                            ]),
                            _createElementVNode("div", _hoisted_378, [
                              _cache[197] || (_cache[197] = _createElementVNode("strong", null, "Description :", -1)),
                              _cache[198] || (_cache[198] = _createElementVNode("br", null, null, -1)),
                              _createTextVNode(" " + _toDisplayString(flag.description), 1)
                            ]),
                            _createElementVNode("div", _hoisted_379, [
                              _createElementVNode("div", _hoisted_380, [
                                _cache[199] || (_cache[199] = _createElementVNode("i", { class: "fas fa-cogs me-1" }, null, -1)),
                                _cache[200] || (_cache[200] = _createElementVNode("strong", null, "Règle :", -1)),
                                _createTextVNode(" " + _toDisplayString(flag.rule?.name || 'Non spécifiée'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_381, [
                                _cache[201] || (_cache[201] = _createElementVNode("i", { class: "fas fa-clock me-1" }, null, -1)),
                                _cache[202] || (_cache[202] = _createElementVNode("strong", null, "Détecté le :", -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(flag.createdAt)), 1)
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.totalWarningFlags > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_382, [
                      _createElementVNode("div", _hoisted_383, [
                        _cache[204] || (_cache[204] = _createElementVNode("i", { class: "fas fa-info-circle text-info fa-lg me-2" }, null, -1)),
                        _createElementVNode("h6", _hoisted_384, " AVERTISSEMENTS (" + _toDisplayString(_ctx.totalWarningFlags) + ") ", 1)
                      ]),
                      _cache[205] || (_cache[205] = _createElementVNode("p", { class: "text-muted small mb-3" }, " Points d'attention ne bloquant pas l'émission mais méritant d'être vérifiés. ", -1)),
                      _createElementVNode("div", _hoisted_385, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warningFlags, (flag, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: flag.id,
                            class: "accordion-item"
                          }, [
                            _createElementVNode("h2", _hoisted_386, [
                              _createElementVNode("button", {
                                class: "accordion-button collapsed",
                                type: "button",
                                "data-bs-toggle": 'collapse',
                                "data-bs-target": '#warning' + flag.id
                              }, [
                                _createElementVNode("span", _hoisted_388, _toDisplayString(index + 1), 1),
                                _createTextVNode(" " + _toDisplayString(flag.title), 1)
                              ], 8, _hoisted_387)
                            ]),
                            _createElementVNode("div", {
                              id: 'warning' + flag.id,
                              class: "accordion-collapse collapse",
                              "data-bs-parent": "#warningsAccordion"
                            }, [
                              _createElementVNode("div", _hoisted_390, [
                                _createElementVNode("p", null, _toDisplayString(flag.description), 1),
                                _createElementVNode("small", _hoisted_391, " Règle : " + _toDisplayString(flag.rule?.name) + " • Détecté le " + _toDisplayString(_ctx.formatDateTime(flag.createdAt)), 1)
                              ])
                            ], 8, _hoisted_389)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.totalAllFlags === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_392, [...(_cache[206] || (_cache[206] = [
                      _createElementVNode("i", { class: "fas fa-check-circle fa-4x text-success mb-3" }, null, -1),
                      _createElementVNode("h5", { class: "text-success" }, "Aucune alerte détectée", -1),
                      _createElementVNode("p", { class: "text-muted" }, " Tous les contrôles automatiques sont passés avec succès. ", -1)
                    ]))]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_393, [
                _createElementVNode("div", _hoisted_394, [
                  _cache[208] || (_cache[208] = _createElementVNode("small", { class: "text-muted" }, [
                    _createElementVNode("i", { class: "fas fa-robot me-1" }),
                    _createTextVNode(" Contrôles générés automatiquement par le moteur de règles ")
                  ], -1)),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showFlagsModal = false))
                  }, [...(_cache[207] || (_cache[207] = [
                    _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1),
                    _createTextVNode(" Fermer ", -1)
                  ]))])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showCorrectionRequestModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "modal-backdrop fade show",
          onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showCorrectionRequestModal = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showCorrectionRequestModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_395, [
          _createElementVNode("div", _hoisted_396, [
            _createElementVNode("div", _hoisted_397, [
              _createElementVNode("div", _hoisted_398, [
                _createElementVNode("div", _hoisted_399, [
                  _createElementVNode("h6", _hoisted_400, [
                    _cache[209] || (_cache[209] = _createElementVNode("i", { class: "fas fa-paper-plane me-2" }, null, -1)),
                    _createTextVNode(" Demande de Correction Groupée (" + _toDisplayString(_ctx.allCorrections.length) + ") ", 1)
                  ])
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showCorrectionRequestModal = false))
                })
              ]),
              _createElementVNode("div", _hoisted_401, [
                _createElementVNode("div", _hoisted_402, [
                  _cache[210] || (_cache[210] = _createElementVNode("h6", { class: "text-primary fw-semibold mb-2" }, [
                    _createElementVNode("i", { class: "fas fa-list me-2" }),
                    _createTextVNode(" Corrections détectées ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_403, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCorrections, (correction, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["d-flex align-items-start gap-2 mb-2 p-2 bg-white rounded border-start border-3", correction.result === 'FAILED' ? 'border-danger' : 'border-warning'])
                      }, [
                        _createElementVNode("span", _hoisted_404, _toDisplayString(index + 1), 1),
                        _createElementVNode("div", _hoisted_405, [
                          _createElementVNode("div", _hoisted_406, _toDisplayString(correction.checkTitle), 1),
                          _createElementVNode("div", _hoisted_407, _toDisplayString(correction.taskName), 1),
                          _createElementVNode("div", _hoisted_408, _toDisplayString(correction.correctionNeeded), 1)
                        ]),
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge d-flex align-items-center justify-content-center flex-shrink-0", correction.result === 'FAILED' ? 'bg-danger' : 'bg-warning text-dark']),
                          style: {"width":"18px","height":"18px","border-radius":"4px","font-size":"9px"}
                        }, _toDisplayString(correction.result === 'FAILED' ? 'C' : 'A'), 3)
                      ], 2))
                    }), 128))
                  ])
                ]),
                _createVNode(_component_Form, {
                  ref: "CorrectionRequestForm",
                  onSubmit: _ctx.addCorrectionRequest,
                  "validation-schema": _ctx.validationCorrectionSchema
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_409, [
                      _createElementVNode("div", _hoisted_410, [
                        _cache[211] || (_cache[211] = _createElementVNode("label", { class: "form-label small fw-semibold" }, [
                          _createTextVNode(" Date d'émission "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "requested_at",
                          type: "date",
                          class: "form-control form-control-sm"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "requested_at",
                          class: "text-danger small"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_411, [
                        _cache[212] || (_cache[212] = _createElementVNode("label", { class: "form-label small fw-semibold" }, [
                          _createTextVNode(" Date limite "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "due_date",
                          type: "date",
                          class: "form-control form-control-sm"
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "due_date",
                          class: "text-danger small"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_412, [
                        _cache[213] || (_cache[213] = _createElementVNode("label", { class: "form-label small fw-semibold" }, [
                          _createTextVNode(" Message au transitaire "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ], -1)),
                        _createVNode(_component_Field, {
                          name: "message_to_requester",
                          as: "textarea",
                          class: "form-control form-control-sm",
                          rows: "4",
                          placeholder: "Décrivez les corrections à apporter..."
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "message_to_requester",
                          class: "text-danger small"
                        }),
                        _cache[214] || (_cache[214] = _createElementVNode("small", { class: "text-muted" }, [
                          _createElementVNode("i", { class: "fas fa-info-circle me-1" }),
                          _createTextVNode(" Les détails des corrections seront automatiquement inclus à partir des commentaires ajoutés ")
                        ], -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_413, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary btn-sm",
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.showCorrectionRequestModal = false))
                      }, [...(_cache[215] || (_cache[215] = [
                        _createElementVNode("i", { class: "fas fa-times me-1" }, null, -1),
                        _createTextVNode(" Annuler ", -1)
                      ]))]),
                      _cache[216] || (_cache[216] = _createElementVNode("button", {
                        type: "submit",
                        class: "btn btn-primary btn-sm"
                      }, [
                        _createElementVNode("i", { class: "fas fa-paper-plane me-1" }),
                        _createTextVNode(" Envoyer la demande de correction ")
                      ], -1))
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit", "validation-schema"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showValidationModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: "modal-backdrop fade show",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.showValidationModal = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.showValidationModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_414, [
          _createElementVNode("div", _hoisted_415, [
            _createElementVNode("div", _hoisted_416, [
              _createElementVNode("div", _hoisted_417, [
                _cache[217] || (_cache[217] = _createElementVNode("h5", { class: "modal-title text-white" }, [
                  _createElementVNode("i", { class: "fas fa-clipboard-check me-2" }),
                  _createTextVNode(" Validation du dossier ")
                ], -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.showValidationModal = false))
                })
              ]),
              _createElementVNode("div", _hoisted_418, [
                _cache[221] || (_cache[221] = _createElementVNode("div", { class: "alert alert-info" }, [
                  _createElementVNode("i", { class: "fas fa-info-circle me-2" }),
                  _createTextVNode(" Vous êtes sur le point de prendre une décision sur ce dossier BESC après avoir effectué tous les contrôles. ")
                ], -1)),
                _createElementVNode("div", _hoisted_419, [
                  _createElementVNode("div", _hoisted_420, [
                    _createElementVNode("div", _hoisted_421, [
                      _createElementVNode("div", _hoisted_422, [
                        _createElementVNode("div", _hoisted_423, [
                          _createElementVNode("h6", _hoisted_424, _toDisplayString(_ctx.validationTasks.length), 1),
                          _cache[218] || (_cache[218] = _createElementVNode("small", { class: "text-muted" }, "Tâches complétées", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_425, [
                      _createElementVNode("div", _hoisted_426, [
                        _createElementVNode("div", _hoisted_427, [
                          _createElementVNode("h6", _hoisted_428, _toDisplayString(_ctx.getTotalChecksCount()), 1),
                          _cache[219] || (_cache[219] = _createElementVNode("small", null, "Contrôles", -1))
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_429, [
                  _cache[220] || (_cache[220] = _createElementVNode("label", { class: "form-label fw-semibold" }, "Commentaire (optionnel)", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.validationComment) = $event)),
                    class: "form-control",
                    rows: "4",
                    placeholder: "Ajoutez un commentaire sur votre décision..."
                  }, null, 512), [
                    [_vModelText, _ctx.validationComment]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_430, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showValidationModal = false))
                }, " Annuler "),
                (_ctx.totalCriticalFlags > 0 || _ctx.allCorrections.length > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-danger me-2",
                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.validateDossier('REJECTED')))
                    }, " Rejeter le dossier "))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-success",
                  onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.validateDossier('VALIDATED'))),
                  disabled: _ctx.validatingDossier
                }, [
                  _cache[222] || (_cache[222] = _createElementVNode("i", { class: "fas fa-check me-2" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.validatingDossier ? 'Traitement...' : 'Valider le dossier'), 1)
                ], 8, _hoisted_431)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}